// import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import { map } from 'rxjs/operators';
// import { BehaviorSubject, Observable } from 'rxjs';
// import { Menu } from '../../model/menu.model';
// import { CoreGymService } from '../../_services/core.gym.service.service';
// import { Guid } from '../../_helpers/guid';




// @Injectable({
//  providedIn: 'root'
// })

// export class MenuService {

//  lostOfMenu: Array<Menu> = [];

//  private menuList = new BehaviorSubject(this.lostOfMenu);
//  getMenus = this.menuList.asObservable();

//  constructor(
//    private readonly http: HttpClient,
//    private readonly coreGymService: CoreGymService
//  ) {
//  }

//  setmenu(menu: Array<Menu>) {
//    menu = menu.sort(function (a, b) {
//      return a.displayOrder - b.displayOrder;
//    });
//    this.menuList.next(menu);
//  }

//  mergeMenu(menu: Menu, action: string): Observable<Response> {
//    let httpheader = new HttpHeaders();
//    httpheader = httpheader.append('Content-Type', 'application/json');
//    let url: string = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    if (action === 'Edit' || action === 'Delete') {
//      url = url + '/' + menu.menuUId;
//      return this.http.put(url, JSON.stringify(menu), { 'headers': httpheader })
//        .pipe(map((data: Response) => data,
//          (error: HttpErrorResponse): void => {
//            console.log(error);
//          }
//        ));
//    } else {
//      return this.http.post(url, JSON.stringify(menu), { 'headers': httpheader })
//        .pipe(map((data: Response) => data,
//          (error: HttpErrorResponse): void => {
//            console.log(error);
//          }
//        ));
//    }
//  }

//  getMenu(menuUId?: string): Observable<Array<Menu>> {
//    let url: string = this.coreGymService.BaseUrl!;
//    if (menuUId) {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUIdUrl'];
//      url = url.replace('{id}', menuUId ? menuUId : Guid.empty);
//      return this.http.get(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => { }));
//    }
//    else {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//      return this.http.get(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => { }));
//    }

//  }

//  getMenuProduct(ProductUId?: string, RoleBasedMenus?: string): Observable<Array<Menu>> {
//    let url: string = this.coreGymService.BaseUrl!;
//    if (ProductUId) {
//      url = url + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//      url = url.replace('{ProductUId}', ProductUId ? ProductUId : Guid.empty);
//      url = url.replace('{RoleBasedMenus}', RoleBasedMenus ? RoleBasedMenus : Guid.empty);
//      return this.http.get(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => { }));
//    }
//    else {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//      return this.http.get(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => { }));
//    }

//  }
//  deleteMenu(menuUId: Guid): Observable<Array<Menu>> {
//    let url: string = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    url = url + '/' + menuUId;
//    return this.http.delete(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => { }));

//  }
// }



// import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
// import { map } from 'rxjs/operators';
// import { BehaviorSubject, Observable, throwError } from 'rxjs';
// import { Menu } from '../../model/menu.model';
// import { CoreGymService } from '../../_services/core.gym.service.service';
// import { Guid } from '../../_helpers/guid';

// export type UserGroupUgid = string;

// export interface DashboardMenuRequest {
//   apiUrl: string;
//   productUId?: string;
//   userGroupUgid?: UserGroupUgid;
//   productParamName?: string;
//   ugidParamName?: string;
// }

// export interface DashboardMenuItem {
//   id: string;
//   label: string;
//   iconKey: string;
//   route?: string;
//   badge?: string;
//   hint?: string;
//   accentClass?: string;
//   dashboardGroup?: string;
//   showInDashboard?: boolean;
//   sortOrder: number;
//   section: string;
//   toastTitle?: string;
//   toastMessage?: string;
// }

// export interface DashboardMenuSection {
//   label: string;
//   sortOrder: number;
//   items: DashboardMenuItem[];
// }

// type MenuRow = Record<string, unknown>;

// // ─── Section inference ─────────────────────────────────────────
// // Used when the API doesn't return a usable `Section` value for a row.
// // We map menu labels / routes to one of these canonical sections and
// // give each section a stable sort order so the sidebar always groups
// // the same way regardless of row order.
// const SECTION_ORDER: Record<string, number> = {
//   'Main': 10,
//   'Account & Management': 20,
//   'Registration': 30,
//   'Customer Management': 40,
//   'Product Management': 50,
//   'Orders': 60,
//   'Payments': 70,
//   'Billing & Invoices': 80,
//   'Attendance & Reports': 90,
//   'Configuration': 100,
//   'Menu': 999,
// };

// @Injectable({
//   providedIn: 'root'
// })
// export class MenuService {
//   lostOfMenu: Array<Menu> = [];

//   private menuList = new BehaviorSubject<Array<Menu>>(this.lostOfMenu);
//   menus$ = this.menuList.asObservable();

//   constructor(
//     private readonly http: HttpClient,
//     private readonly coreGymService: CoreGymService
//   ) { }

//   setmenu(menu: Array<Menu>): void {
//     const sortedMenu = [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//     this.menuList.next(sortedMenu);
//   }

//   mergeMenu(menu: Menu, action: string): Observable<Response> {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     let url = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];

//     if (action === 'Edit' || action === 'Delete') {
//       url = url + '/' + menu.menuUId;
//       return this.http.put(url, JSON.stringify(menu), { headers: httpheader })
//         .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//     }

//     return this.http.post(url, JSON.stringify(menu), { headers: httpheader })
//       .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//   }

//   getMenus(): Observable<Array<Menu>> {
//     let url = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//     return this.http.get<Array<Menu>>(url)
//       .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//   }

//   getMenuById(menuUId: string): Observable<Array<Menu>> {
//     let url = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetMenuUIdUrl'];
//     url = url.replace('{id}', menuUId || Guid.empty);
//     return this.http.get<Array<Menu>>(url)
//       .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//   }

//   getDashboardMenus(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//     return this.getDashboardMenu(request);
//   }

//   getDashboardMenusProduct(productUId: string, ugid: string): Observable<DashboardMenuSection[]> {
//     // Endpoint from serviceUrls may include a "?ProductUId={ProductUId}&..." template — drop it.
//     let url = this.coreGymService.BaseUrl + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//     url = url.split('?')[0];   // <-- removes the {ProductUId}&{RoleBasedMenus} template

//     let params = new HttpParams().set('ProductUId', productUId || '');
//     params = params.set('ugid', ugid || Guid.empty);
//     if (ugid) { params = params.set('UGID', ugid); }   // only if your API actually reads UGID

//     return this.http.get<DashboardMenuSection[]>(url, { params });
//   }

//   getMenu(): Observable<Array<Menu>>;
//   getMenu(menuUId: string): Observable<Array<Menu>>;
//   getMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]>;
//   getMenu(menuUIdOrRequest?: string | DashboardMenuRequest): Observable<Array<Menu> | DashboardMenuSection[]> {
//     if (menuUIdOrRequest && typeof menuUIdOrRequest === 'object') {
//       return this.getDashboardMenus(menuUIdOrRequest);
//     }
//     if (menuUIdOrRequest) {
//       return this.getMenuById(menuUIdOrRequest.toString());
//     }
//     return this.getMenus();
//   }

//   getMenuProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<Array<Menu>> {
//     let url = this.coreGymService.BaseUrl!;
//     if (!productUId) {
//       url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//       return this.http.get<Array<Menu>>(url)
//         .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//     }

//     const ugid = this.sanitizeUgid(userGroupUgid);
//     url = url + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//     url = url.replace('{ProductUId}', productUId || Guid.empty);
//     url = url.replace('{RoleBasedMenus}', ugid ?? '');
//     url = url.replace('{UGID}', ugid ?? '');

//     return this.http.get<Array<Menu>>(url)
//       .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//   }

//   deleteMenu(menuUId: Guid): Observable<Array<Menu>> {
//     let url = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//     url = url + '/' + menuUId;
//     return this.http.delete<Array<Menu>>(url)
//       .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//   }

//   private getDashboardMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//     const sanitizedRequest: DashboardMenuRequest = {
//       ...request,
//       userGroupUgid: this.sanitizeUgid(request.userGroupUgid),
//     };
//     return this.http
//       .get<unknown>(this.buildDashboardMenuUrl(sanitizedRequest))
//       .pipe(map((response) => this.toDashboardSections(response)));
//   }

//   private buildDashboardMenuUrl(request: DashboardMenuRequest): string {
//     const productParamName = request.productParamName || 'ProductUId';
//     const ugidParamName = request.ugidParamName || 'RoleBasedMenus';
//     let url = request.apiUrl;

//     url = this.replacePlaceholder(url, productParamName, request.productUId);
//     url = this.replacePlaceholder(url, 'ProductUId', request.productUId);
//     url = this.replacePlaceholder(url, ugidParamName, request.userGroupUgid);
//     url = this.replacePlaceholder(url, 'RoleBasedMenus', request.userGroupUgid);
//     url = this.replacePlaceholder(url, 'UGID', request.userGroupUgid);
//     url = this.replacePlaceholder(url, 'UserGroupUgid', request.userGroupUgid);

//     if (request.productUId && !this.hasPlaceholder(request.apiUrl, productParamName) && !this.hasPlaceholder(request.apiUrl, 'ProductUId')) {
//       url = this.appendQueryParam(url, productParamName, request.productUId);
//     }
//     if (request.userGroupUgid &&
//       !this.hasPlaceholder(request.apiUrl, ugidParamName) &&
//       !this.hasPlaceholder(request.apiUrl, 'RoleBasedMenus') &&
//       !this.hasPlaceholder(request.apiUrl, 'UGID') &&
//       !this.hasPlaceholder(request.apiUrl, 'UserGroupUgid')) {
//       url = this.appendQueryParam(url, ugidParamName, request.userGroupUgid);
//     }
//     return this.withCacheBuster(url);
//   }

//   private toDashboardSections(response: unknown): DashboardMenuSection[] {
//     const rows = this.extractRows(response);
//     const activeRows = rows.filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true));
//     const sectionMap = new Map<string, DashboardMenuSection>();

//     activeRows.forEach((row, index) => {
//       const item = this.toDashboardMenuItem(row, index);
//       if (!item.label) return;

//       if (!sectionMap.has(item.section)) {
//         sectionMap.set(item.section, {
//           label: item.section,
//           sortOrder: SECTION_ORDER[item.section] ??
//             this.readNumber(row, ['section_order', 'sectionOrder', 'group_order'], 500 + sectionMap.size),
//           items: [],
//         });
//       }
//       sectionMap.get(item.section)?.items.push(item);
//     });

//     return Array.from(sectionMap.values())
//       .map((s) => ({ ...s, items: s.items.sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label)) }))
//       .sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label));
//   }

//   private toDashboardMenuItem(row: MenuRow, index: number): DashboardMenuItem {
//     const label = this.readString(row, ['title', 'Title', 'menu_name', 'menuName', 'MenuName', 'label', 'name']);
//     const route = this.readString(row, ['page', 'Page', 'route', 'routerLink', 'router_link', 'path', 'url']);
//     const rawIcon = this.readString(row, ['icon', 'Icon', 'icon_key', 'iconKey', 'icon_name', 'iconName']);
//     const apiSect = this.readString(row, ['section', 'Section', 'section_name', 'sectionName', 'menu_group', 'menuGroup']);
//     const section = this.resolveSection(apiSect, label, route);

//     return {
//       id: this.readString(row, ['menuUId', 'MenuUId', 'menu_id', 'menuId', 'id']) || `${section}-${label || index}`,
//       label,
//       section,
//       route,
//       iconKey: this.toIconKey(rawIcon || label || section),
//       badge: this.readString(row, ['badgeValue', 'BadgeValue', 'badge', 'badge_count']),
//       hint: this.readString(row, ['description', 'hint', 'subtitle']),
//       sortOrder: this.readNumber(row, ['displayOrder', 'DisplayOrder', 'sort_order', 'sortOrder'], index + 1),
//       showInDashboard: this.readOptionalBoolean(row, ['show_on_dashboard', 'showOnDashboard']) ?? label.toLowerCase() !== 'dashboard',
//     };
//   }

//   /**
//    * Picks the section a menu row belongs to.
//    *
//    * If the API gives us a real-looking section name (not "Menu", "MENU",
//    * "Default", or empty), we trust it. Otherwise we infer from the label
//    * and route using keyword matching, so existing menu tables that don't
//    * have section columns still produce a properly grouped sidebar.
//    */
//   private resolveSection(apiSection: string, label: string, route: string): string {
//     const trimmed = (apiSection || '').trim();
//     const lower = trimmed.toLowerCase();
//     const isPlaceholder = !trimmed || lower === 'menu' || lower === 'default' || lower === 'main menu' || lower === 'navigation';
//     if (!isPlaceholder) {
//       return trimmed;
//     }
//     return this.inferSection(label, route);
//   }

//   private inferSection(label: string, route: string): string {
//     const haystack = `${label} ${route}`.toLowerCase();
//     const has = (...needles: string[]) => needles.some((n) => haystack.includes(n));

//     if (has('dashboard', 'home', 'overview')) return 'Main';
//     if (has('account creation', 'accountcreation', 'account')) return 'Account & Management';
//     if (has('manager', 'supervisor', 'supplier', 'staff', 'employee')) return 'Registration';
//     if (has('customer', 'client', 'guest')) return 'Customer Management';
//     if (has('product', 'store', 'inventory', 'stock', 'item')) return 'Product Management';
//     if (has('order')) return 'Orders';
//     if (has('payment', 'receipt')) return 'Payments';
//     if (has('invoice', 'bill')) return 'Billing & Invoices';
//     if (has('attendance', 'report')) return 'Attendance & Reports';
//     if (has('tax', 'setup', 'setting', 'config', 'master')) return 'Configuration';

//     return 'Menu';
//   }

//   private sortMenu(menu: Array<Menu>): Array<Menu> {
//     return [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//   }

//   private extractRows(response: unknown): MenuRow[] {
//     if (Array.isArray(response)) return response.filter(this.isRecord);
//     if (!this.isRecord(response)) return [];
//     const candidates = [response['data'], response['menus'], response['menu'], response['items'], response['rows'], response['result']];
//     for (const c of candidates) if (Array.isArray(c)) return c.filter(this.isRecord);
//     return [];
//   }

//   private readString(row: MenuRow, keys: string[]): string {
//     for (const key of keys) {
//       const value = row[key];
//       if (value !== undefined && value !== null && String(value).trim() !== '') return String(value).trim();
//     }
//     return '';
//   }

//   private readNumber(row: MenuRow, keys: string[], fallback: number): number {
//     for (const key of keys) {
//       const parsed = Number(row[key]);
//       if (Number.isFinite(parsed)) return parsed;
//     }
//     return fallback;
//   }

//   private readBoolean(row: MenuRow, keys: string[], fallback: boolean): boolean {
//     const v = this.readOptionalBoolean(row, keys);
//     return v ?? fallback;
//   }

//   private readOptionalBoolean(row: MenuRow, keys: string[]): boolean | null {
//     for (const key of keys) {
//       if (!(key in row)) continue;
//       const v = row[key];
//       if (typeof v === 'boolean') return v;
//       if (typeof v === 'number') return v === 1;
//       if (typeof v === 'string') return ['1', 'true', 'yes', 'y', 'active'].includes(v.trim().toLowerCase());
//     }
//     return null;
//   }

//   private toIconKey(value: string): string {
//     const n = value.toLowerCase().replace(/[^a-z0-9]+/g, '');
//     if (n.includes('dashboard') || n.includes('home')) return 'dashboard';
//     if (n.includes('accountcreation') || n.includes('account')) return 'user';
//     if (n.includes('supervisor') || n.includes('eye') || n.includes('view')) return 'eye';
//     if (n.includes('supplier') || n.includes('truck') || n.includes('vendor')) return 'truck';
//     if (n.includes('manager') || n.includes('staff') || n.includes('employee')) return 'user';
//     if (n.includes('customer') || n.includes('client')) return 'users';
//     if (n.includes('attendance') || n.includes('report')) return 'report';
//     if (n.includes('product') || n.includes('store') || n.includes('inventory')) return 'order';
//     if (n.includes('order') || n.includes('bill') || n.includes('invoice')) return 'order';
//     if (n.includes('user')) return 'user';
//     return 'menu';
//   }

//   private sanitizeUgid(value?: UserGroupUgid | null): string {
//     if (value === null || value === undefined) return '';
//     const t = String(value).trim();
//     if (!t || t.toLowerCase() === 'null' || t.toLowerCase() === 'undefined') return '';
//     return t;
//   }

//   private replacePlaceholder(url: string, key: string, value?: string): string {
//     return value ? url.replace(new RegExp(`\\{${key}\\}`, 'g'), encodeURIComponent(value)) : url;
//   }
//   private appendQueryParam(url: string, key: string, value: string): string {
//     const sep = url.includes('?') ? '&' : '?';
//     return `${url}${sep}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//   }
//   private hasPlaceholder(url: string, key: string): boolean { return url.includes(`{${key}}`); }
//   private withCacheBuster(url: string): string {
//     const sep = url.includes('?') ? '&' : '?';
//     return `${url}${sep}_=${Date.now()}`;
//   }
//   private isRecord(value: unknown): value is MenuRow {
//     return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
//   }
// }



//import { HttpClient } from '@angular/common/http';
//import { Injectable } from '@angular/core';
//import { map, Observable, throwError } from 'rxjs';

//export type UserGroupUgid = string;

//export interface DashboardMenuRequest {
//  apiUrl: string;
//  productUId?: string;
//  userGroupUgid?: UserGroupUgid;
//  productParamName?: string;
//  ugidParamName?: string;
//}

//export interface DashboardMenuItem {
//  id: string;
//  label: string;
//  iconKey: string;
//  route?: string;
//  badge?: string;
//  hint?: string;
//  accentClass?: string;
//  dashboardGroup?: string;
//  showInDashboard?: boolean;
//  sortOrder: number;
//  section: string;
//  toastTitle?: string;
//  toastMessage?: string;
//}

//export interface DashboardMenuSection {
//  label: string;
//  sortOrder: number;
//  items: DashboardMenuItem[];
//}

//type MenuRow = Record<string, unknown>;

//@Injectable({ providedIn: 'root' })
//export class MenuService {
//  constructor(private readonly http: HttpClient) { }

//  getMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//    const userGroupUgid = request.userGroupUgid?.trim();
//    if (userGroupUgid && !this.isValidUserGroupUgid(userGroupUgid)) {
//      return throwError(() => new Error('UGID must be exactly 16 alphanumeric characters.'));
//    }

//    return this.http
//      .get<unknown>(this.buildMenuUrl({ ...request, userGroupUgid }))
//      .pipe(map((response) => this.toSections(response)));
//  }

//  private buildMenuUrl(request: DashboardMenuRequest): string {
//    const productParamName = request.productParamName || 'ProductUId';
//    const ugidParamName = request.ugidParamName || 'RoleBasedMenus';
//    let url = request.apiUrl;

//    url = this.replacePlaceholder(url, productParamName, request.productUId);
//    url = this.replacePlaceholder(url, 'ProductUId', request.productUId);
//    url = this.replacePlaceholder(url, ugidParamName, request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'RoleBasedMenus', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UGID', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UserGroupUgid', request.userGroupUgid);

//    if (request.productUId && !this.hasPlaceholder(request.apiUrl, productParamName) && !this.hasPlaceholder(request.apiUrl, 'ProductUId')) {
//      url = this.appendQueryParam(url, productParamName, request.productUId);
//    }

//    if (
//      request.userGroupUgid &&
//      !this.hasPlaceholder(request.apiUrl, ugidParamName) &&
//      !this.hasPlaceholder(request.apiUrl, 'RoleBasedMenus') &&
//      !this.hasPlaceholder(request.apiUrl, 'UGID') &&
//      !this.hasPlaceholder(request.apiUrl, 'UserGroupUgid')
//    ) {
//      url = this.appendQueryParam(url, ugidParamName, request.userGroupUgid);
//    }

//    return this.withCacheBuster(url);
//  }

//  private toSections(response: unknown): DashboardMenuSection[] {
//    const groupedSections = this.extractGroupedSections(response);
//    if (groupedSections.length) {
//      return groupedSections;
//    }

//    const rows = this.extractRows(response);
//    const activeRows = rows.filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true));
//    const items = activeRows.map((row, index) => this.toMenuItem(row, index)).filter((item) => item.label);
//    const sectionMap = new Map<string, DashboardMenuSection>();

//    items.forEach((item) => {
//      if (!sectionMap.has(item.section)) {
//        sectionMap.set(item.section, {
//          label: item.section,
//          sortOrder: this.readSectionOrder(activeRows, item.section) ?? sectionMap.size + 1,
//          items: [],
//        });
//      }

//      sectionMap.get(item.section)?.items.push(item);
//    });

//    return Array.from(sectionMap.values())
//      .map((section) => ({
//        ...section,
//        items: section.items.sort((left, right) => left.sortOrder - right.sortOrder || left.label.localeCompare(right.label)),
//      }))
//      .sort((left, right) => left.sortOrder - right.sortOrder || left.label.localeCompare(right.label));
//  }

//  private extractGroupedSections(response: unknown): DashboardMenuSection[] {
//    const possibleSections = this.extractPossibleSectionArray(response);
//    const sections = possibleSections
//      .filter((section) => this.readChildRows(section).length > 0)
//      .map((section, sectionIndex) => {
//        const label =
//          this.readString(section, [
//            'section_name',
//            'sectionName',
//            'SectionName',
//            'menu_group',
//            'menuGroup',
//            'group_name',
//            'label',
//            'name',
//            'title',
//          ]) || `Section ${sectionIndex + 1}`;
//        const items = this.readChildRows(section)
//          .filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true))
//          .map((row, itemIndex) => this.toMenuItem({ ...row, section_name: label }, itemIndex))
//          .filter((item) => item.label)
//          .sort((left, right) => left.sortOrder - right.sortOrder || left.label.localeCompare(right.label));

//        return {
//          label,
//          sortOrder: this.readNumber(section, ['section_order', 'sectionOrder', 'sort_order', 'sortOrder'], sectionIndex + 1),
//          items,
//        };
//      })
//      .filter((section) => section.items.length > 0);

//    return sections.sort((left, right) => left.sortOrder - right.sortOrder || left.label.localeCompare(right.label));
//  }

//  private extractPossibleSectionArray(response: unknown): MenuRow[] {
//    if (Array.isArray(response)) {
//      return response.filter(this.isRecord);
//    }

//    if (!this.isRecord(response)) {
//      return [];
//    }

//    const candidates = [
//      response['sections'],
//      response['navSections'],
//      response['menuSections'],
//      response['data'],
//      response['menus'],
//      response['menu'],
//      response['items'],
//      response['result'],
//    ];

//    for (const candidate of candidates) {
//      if (Array.isArray(candidate)) {
//        return candidate.filter(this.isRecord);
//      }
//    }

//    return [];
//  }

//  private readChildRows(section: MenuRow): MenuRow[] {
//    const candidates = [section['items'], section['children'], section['menus'], section['menuItems'], section['subMenus']];
//    for (const candidate of candidates) {
//      if (Array.isArray(candidate)) {
//        return candidate.filter(this.isRecord);
//      }
//    }

//    return [];
//  }

//  private extractRows(response: unknown): MenuRow[] {
//    if (Array.isArray(response)) {
//      return response.filter(this.isRecord);
//    }

//    if (!this.isRecord(response)) {
//      return [];
//    }

//    const candidates = [
//      response['data'],
//      response['menus'],
//      response['menu'],
//      response['items'],
//      response['rows'],
//      response['result'],
//    ];

//    for (const candidate of candidates) {
//      if (Array.isArray(candidate)) {
//        return candidate.filter(this.isRecord);
//      }
//    }

//    return [];
//  }

//  private toMenuItem(row: MenuRow, index: number): DashboardMenuItem {
//    const label = this.readString(row, ['menu_name', 'menuName', 'MenuName', 'label', 'name', 'title', 'display_name']);
//    const section =
//      this.readString(row, [
//        'section_name',
//        'sectionName',
//        'SectionName',
//        'menu_group',
//        'menuGroup',
//        'group_name',
//        'parent_menu_name',
//        'parentMenuName',
//        'ParentMenuName',
//        'parent_name',
//        'parentName',
//        'category',
//        'module_name',
//      ]) || 'Menu';
//    const route = this.readString(row, [
//      'route',
//      'routerLink',
//      'router_link',
//      'path',
//      'url',
//      'menu_url',
//      'menuLink',
//      'menu_link',
//      'MenuUrl',
//    ]);
//    const id =
//      this.readString(row, ['menu_id', 'menuId', 'MenuID', 'MenuId', 'id', 'Id', 'code']) ||
//      `${section}-${label || index}`.toLowerCase().replace(/[^a-z0-9]+/g, '-');
//    const iconValue = this.readString(row, ['icon_key', 'iconKey', 'icon_name', 'iconName', 'icon', 'Icon']);
//    const iconKey = this.toIconKey(iconValue || label || section);
//    const explicitDashboardFlag = this.readOptionalBoolean(row, [
//      'show_on_dashboard',
//      'showOnDashboard',
//      'display_on_dashboard',
//      'displayOnDashboard',
//      'is_dashboard',
//      'isDashboard',
//    ]);
//    const displayAreaDashboardFlag = this.readDashboardDisplayFlag(row);
//    const isDashboardItem = this.toIconKey(label) === 'dashboard' || route.toLowerCase() === 'dashboard';

//    return {
//      id,
//      label,
//      section,
//      route,
//      iconKey,
//      badge: this.readString(row, ['badge', 'badge_count', 'badgeCount', 'notification_count']),
//      hint:
//        this.readString(row, [
//          'hint',
//          'description',
//          'menu_description',
//          'menuDescription',
//          'subtitle',
//          'card_subtitle',
//          'cardSubtitle',
//        ]) || this.toDefaultHint(label, route),
//      accentClass:
//        this.readString(row, ['accent_class', 'accentClass', 'color_class', 'colorClass', 'card_class', 'cardClass']) ||
//        this.toAccentClass(iconKey, index),
//      dashboardGroup:
//        this.readString(row, [
//          'dashboard_group',
//          'dashboardGroup',
//          'card_group',
//          'cardGroup',
//          'display_group',
//          'displayGroup',
//        ]) || this.toDashboardGroup(section),
//      showInDashboard: explicitDashboardFlag ?? displayAreaDashboardFlag ?? !isDashboardItem,
//      sortOrder: this.readNumber(
//        row,
//        ['sort_order', 'sortOrder', 'display_order', 'displayOrder', 'order_no', 'menu_order', 'menuOrder'],
//        index + 1
//      ),
//      toastTitle: this.readString(row, ['toast_title', 'toastTitle']),
//      toastMessage: this.readString(row, ['toast_message', 'toastMessage']),
//    };
//  }

//  private readString(row: MenuRow, keys: string[]): string {
//    for (const key of keys) {
//      const value = row[key];
//      if (value !== undefined && value !== null && String(value).trim() !== '') {
//        return String(value).trim();
//      }
//    }

//    return '';
//  }

//  private readNumber(row: MenuRow, keys: string[], fallback: number): number {
//    for (const key of keys) {
//      const value = row[key];
//      const parsed = Number(value);
//      if (Number.isFinite(parsed)) {
//        return parsed;
//      }
//    }

//    return fallback;
//  }

//  private readOptionalBoolean(row: MenuRow, keys: string[]): boolean | null {
//    for (const key of keys) {
//      if (!(key in row)) {
//        continue;
//      }

//      const value = row[key];
//      if (typeof value === 'boolean') {
//        return value;
//      }

//      if (typeof value === 'number') {
//        return value === 1;
//      }

//      if (typeof value === 'string') {
//        return ['1', 'true', 'yes', 'y', 'active'].includes(value.trim().toLowerCase());
//      }
//    }

//    return null;
//  }

//  private readDashboardDisplayFlag(row: MenuRow): boolean | null {
//    const displayArea = this.readString(row, [
//      'display_area',
//      'displayArea',
//      'menu_area',
//      'menuArea',
//      'render_area',
//      'renderArea',
//      'menu_type',
//      'menuType',
//    ]).toLowerCase();

//    if (!displayArea) {
//      return null;
//    }

//    if (['dashboard', 'card', 'cards', 'both', 'all', 'sidebar-dashboard', 'vertical-dashboard'].includes(displayArea)) {
//      return true;
//    }

//    if (['sidebar', 'vertical', 'leftnav', 'left-nav', 'nav', 'navigation'].includes(displayArea)) {
//      return false;
//    }

//    return null;
//  }

//  private readBoolean(row: MenuRow, keys: string[], fallback: boolean): boolean {
//    for (const key of keys) {
//      const value = row[key];
//      if (typeof value === 'boolean') {
//        return value;
//      }

//      if (typeof value === 'number') {
//        return value === 1;
//      }

//      if (typeof value === 'string') {
//        return ['1', 'true', 'yes', 'y', 'active'].includes(value.trim().toLowerCase());
//      }
//    }

//    return fallback;
//  }

//  private readSectionOrder(rows: MenuRow[], section: string): number | null {
//    const row = rows.find((candidate) => {
//      const sectionName =
//        this.readString(candidate, [
//          'section_name',
//          'sectionName',
//          'SectionName',
//          'menu_group',
//          'menuGroup',
//          'group_name',
//          'parent_menu_name',
//          'parentMenuName',
//          'ParentMenuName',
//          'parent_name',
//          'parentName',
//          'category',
//          'module_name',
//        ]) || 'Menu';

//      return sectionName === section;
//    });

//    if (!row) {
//      return null;
//    }

//    const order = this.readNumber(row, ['section_order', 'sectionOrder', 'group_order', 'module_order'], Number.NaN);
//    return Number.isFinite(order) ? order : null;
//  }

//  private toIconKey(value: string): string {
//    const normalized = value.toLowerCase().replace(/[^a-z0-9]+/g, '');

//    if (normalized.includes('dashboard') || normalized.includes('home')) {
//      return 'dashboard';
//    }
//    if (normalized.includes('account') || normalized.includes('manager') || normalized.includes('user')) {
//      return 'user';
//    }
//    if (normalized.includes('supervisor') || normalized.includes('eye') || normalized.includes('view')) {
//      return 'eye';
//    }
//    if (normalized.includes('supplier') || normalized.includes('truck') || normalized.includes('vendor')) {
//      return 'truck';
//    }
//    if (normalized.includes('customer') || normalized.includes('client')) {
//      return 'users';
//    }
//    if (normalized.includes('attendance') || normalized.includes('report')) {
//      return 'report';
//    }
//    if (normalized.includes('order') || normalized.includes('bill')) {
//      return 'order';
//    }

//    return 'menu';
//  }

//  private toDashboardGroup(section: string): string {
//    const normalized = section.toLowerCase();
//    if (normalized.includes('order')) {
//      return 'Quick Actions - Orders';
//    }
//    if (normalized.includes('payment') || normalized.includes('report') || normalized.includes('attendance')) {
//      return 'Payments & Reports';
//    }

//    return section;
//  }

//  private toDefaultHint(label: string, route: string): string {
//    const normalized = `${label} ${route}`.toLowerCase();
//    if (normalized.includes('order')) {
//      return 'Open order workflow';
//    }
//    if (normalized.includes('payment')) {
//      return 'View payment details';
//    }
//    if (normalized.includes('attendance')) {
//      return 'View attendance records';
//    }
//    if (normalized.includes('report')) {
//      return 'Analytics and exports';
//    }
//    if (normalized.includes('product') || normalized.includes('store')) {
//      return 'Inventory snapshot';
//    }
//    if (normalized.includes('customer')) {
//      return 'Customer records';
//    }
//    if (normalized.includes('manager') || normalized.includes('supplier') || normalized.includes('supervisor')) {
//      return 'Open registration form';
//    }

//    return 'Open module';
//  }

//  private toAccentClass(iconKey: string, index: number): string {
//    const byIcon: Record<string, string> = {
//      dashboard: 'ac-blue',
//      user: 'ac-indigo',
//      eye: 'ac-violet',
//      truck: 'ac-orange',
//      users: 'ac-teal',
//      report: 'ac-pink',
//      order: 'ac-cyan',
//      menu: 'ac-emerald',
//    };

//    const palette = ['ac-cyan', 'ac-emerald', 'ac-amber', 'ac-rose', 'ac-blue', 'ac-teal', 'ac-orange', 'ac-violet'];
//    return byIcon[iconKey] || palette[index % palette.length];
//  }

//  private withCacheBuster(apiUrl: string): string {
//    const separator = apiUrl.includes('?') ? '&' : '?';
//    return `${apiUrl}${separator}_=${Date.now()}`;
//  }

//  private replacePlaceholder(url: string, key: string, value?: string): string {
//    if (!value) {
//      return url;
//    }

//    return url.replace(new RegExp(`\\{${key}\\}`, 'g'), encodeURIComponent(value));
//  }

//  private appendQueryParam(url: string, key: string, value: string): string {
//    const separator = url.includes('?') ? '&' : '?';
//    return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//  }

//  private hasPlaceholder(url: string, key: string): boolean {
//    return url.includes(`{${key}}`);
//  }

//  private isValidUserGroupUgid(value: string): boolean {
//    return /^[A-Za-z0-9]{16}$/.test(value);
//  }

//  private isRecord(value: unknown): value is MenuRow {
//    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
//  }
//}




//import { Injectable } from '@angular/core';
//import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
//import { map } from 'rxjs/operators';
//import { BehaviorSubject, Observable, throwError } from 'rxjs';
//import { Menu } from '../../model/menu.model';
//import { CoreGymService } from '../../_services/core.gym.service.service';
//import { Guid } from '../../_helpers/guid';

//export type UserGroupUgid = string;

//export interface DashboardMenuRequest {
//  apiUrl: string;
//  productUId?: string;
//  userGroupUgid?: UserGroupUgid;
//  productParamName?: string;
//  ugidParamName?: string;
//}

//export interface DashboardMenuItem {
//  id: string;
//  label: string;
//  iconKey: string;
//  route?: string;
//  badge?: string;
//  hint?: string;
//  accentClass?: string;
//  dashboardGroup?: string;
//  showInDashboard?: boolean;
//  sortOrder: number;
//  section: string;
//  toastTitle?: string;
//  toastMessage?: string;
//}

//export interface DashboardMenuSection {
//  label: string;
//  sortOrder: number;
//  items: DashboardMenuItem[];
//}

//type MenuRow = Record<string, unknown>;

//@Injectable({
//  providedIn: 'root'
//})
//export class MenuService {
//  lostOfMenu: Array<Menu> = [];

//  private readonly ugidPattern = /^[A-Za-z0-9]{16}$/;
//  private menuList = new BehaviorSubject<Array<Menu>>(this.lostOfMenu);
//  getMenus = this.menuList.asObservable();

//  constructor(
//    private readonly http: HttpClient,
//    private readonly coreGymService: CoreGymService
//  ) { }

//  setmenu(menu: Array<Menu>): void {
//    const sortedMenu = [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//    this.menuList.next(sortedMenu);
//  }

//  mergeMenu(menu: Menu, action: string): Observable<Response> {
//    let httpheader = new HttpHeaders();
//    httpheader = httpheader.append('Content-Type', 'application/json');
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];

//    if (action === 'Edit' || action === 'Delete') {
//      url = url + '/' + menu.menuUId;
//      return this.http.put(url, JSON.stringify(menu), { headers: httpheader })
//        .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//    }

//    return this.http.post(url, JSON.stringify(menu), { headers: httpheader })
//      .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//  }

//  getMenu(): Observable<Array<Menu>>;
//  getMenu(menuUId: string): Observable<Array<Menu>>;
//  getMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]>;
//  getMenu(menuUIdOrRequest?: string | DashboardMenuRequest): Observable<Array<Menu> | DashboardMenuSection[]> {
//    if (menuUIdOrRequest && typeof menuUIdOrRequest === 'object') {
//      return this.getDashboardMenu(menuUIdOrRequest);
//    }

//    let url = this.coreGymService.BaseUrl!;
//    if (menuUIdOrRequest) {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUIdUrl'];
//      /*url = url.replace('{id}', menuUIdOrRequest || Guid.empty);*/
//      url = url.replace('{id}', String(menuUIdOrRequest || Guid.empty));
//      return this.http.get<Array<Menu>>(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//    }

//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  getMenuProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;

//    if (!productUId) {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//      return this.http.get<Array<Menu>>(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//    }

//    const ugid = (userGroupUgid || '').trim();
//    if (ugid && !this.ugidPattern.test(ugid)) {
//      return throwError(new Error('UGID must be exactly 16 alphanumeric characters.'));
//    }

//    url = url + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//    url = url.replace('{ProductUId}', productUId || Guid.empty);
//    url = url.replace('{RoleBasedMenus}', ugid || Guid.empty);
//    url = url.replace('{UGID}', ugid || Guid.empty);

//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//  }

//  deleteMenu(menuUId: Guid): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    url = url + '/' + menuUId;
//    return this.http.delete<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  private getDashboardMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//    const ugid = request.userGroupUgid?.trim();
//    if (ugid && !this.ugidPattern.test(ugid)) {
//      return throwError(new Error('UGID must be exactly 16 alphanumeric characters.'));
//    }

//    return this.http
//      .get<unknown>(this.buildDashboardMenuUrl({ ...request, userGroupUgid: ugid }))
//      .pipe(map((response) => this.toDashboardSections(response)));
//  }

//  private buildDashboardMenuUrl(request: DashboardMenuRequest): string {
//    const productParamName = request.productParamName || 'ProductUId';
//    const ugidParamName = request.ugidParamName || 'RoleBasedMenus';
//    let url = request.apiUrl;

//    url = this.replacePlaceholder(url, productParamName, request.productUId);
//    url = this.replacePlaceholder(url, 'ProductUId', request.productUId);
//    url = this.replacePlaceholder(url, ugidParamName, request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'RoleBasedMenus', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UGID', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UserGroupUgid', request.userGroupUgid);

//    if (request.productUId && !this.hasPlaceholder(request.apiUrl, productParamName) && !this.hasPlaceholder(request.apiUrl, 'ProductUId')) {
//      url = this.appendQueryParam(url, productParamName, request.productUId);
//    }

//    if (
//      request.userGroupUgid &&
//      !this.hasPlaceholder(request.apiUrl, ugidParamName) &&
//      !this.hasPlaceholder(request.apiUrl, 'RoleBasedMenus') &&
//      !this.hasPlaceholder(request.apiUrl, 'UGID') &&
//      !this.hasPlaceholder(request.apiUrl, 'UserGroupUgid')
//    ) {
//      url = this.appendQueryParam(url, ugidParamName, request.userGroupUgid);
//    }

//    return this.withCacheBuster(url);
//  }

//  private toDashboardSections(response: unknown): DashboardMenuSection[] {
//    const rows = this.extractRows(response);
//    const activeRows = rows.filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true));
//    const sectionMap = new Map<string, DashboardMenuSection>();

//    activeRows.forEach((row, index) => {
//      const item = this.toDashboardMenuItem(row, index);
//      if (!item.label) {
//        return;
//      }

//      if (!sectionMap.has(item.section)) {
//        sectionMap.set(item.section, {
//          label: item.section,
//          sortOrder: this.readNumber(row, ['section_order', 'sectionOrder', 'group_order'], sectionMap.size + 1),
//          items: [],
//        });
//      }

//      sectionMap.get(item.section)?.items.push(item);
//    });

//    return Array.from(sectionMap.values())
//      .map((section) => ({
//        ...section,
//        items: section.items.sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label)),
//      }))
//      .sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label));
//  }

//  private toDashboardMenuItem(row: MenuRow, index: number): DashboardMenuItem {
//    const label = this.readString(row, ['title', 'Title', 'menu_name', 'menuName', 'MenuName', 'label', 'name']);
//    const section = this.readString(row, ['section', 'Section', 'section_name', 'sectionName', 'menu_group', 'menuGroup']) || 'Menu';
//    const route = this.readString(row, ['page', 'Page', 'route', 'routerLink', 'router_link', 'path', 'url']);
//    const iconValue = this.readString(row, ['icon', 'Icon', 'icon_key', 'iconKey', 'icon_name', 'iconName']);

//    return {
//      id: this.readString(row, ['menuUId', 'MenuUId', 'menu_id', 'menuId', 'id']) || `${section}-${label || index}`,
//      label,
//      section,
//      route,
//      iconKey: this.toIconKey(iconValue || label || section),
//      badge: this.readString(row, ['badgeValue', 'BadgeValue', 'badge', 'badge_count']),
//      hint: this.readString(row, ['description', 'hint', 'subtitle']),
//      sortOrder: this.readNumber(row, ['displayOrder', 'DisplayOrder', 'sort_order', 'sortOrder'], index + 1),
//      showInDashboard: this.readOptionalBoolean(row, ['show_on_dashboard', 'showOnDashboard']) ?? label.toLowerCase() !== 'dashboard',
//    };
//  }

//  private sortMenu(menu: Array<Menu>): Array<Menu> {
//    return [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//  }

//  private extractRows(response: unknown): MenuRow[] {
//    if (Array.isArray(response)) {
//      return response.filter(this.isRecord);
//    }

//    if (!this.isRecord(response)) {
//      return [];
//    }

//    const candidates = [response['data'], response['menus'], response['menu'], response['items'], response['rows'], response['result']];
//    for (const candidate of candidates) {
//      if (Array.isArray(candidate)) {
//        return candidate.filter(this.isRecord);
//      }
//    }

//    return [];
//  }

//  private readString(row: MenuRow, keys: string[]): string {
//    for (const key of keys) {
//      const value = row[key];
//      if (value !== undefined && value !== null && String(value).trim() !== '') {
//        return String(value).trim();
//      }
//    }

//    return '';
//  }

//  private readNumber(row: MenuRow, keys: string[], fallback: number): number {
//    for (const key of keys) {
//      const parsed = Number(row[key]);
//      if (Number.isFinite(parsed)) {
//        return parsed;
//      }
//    }

//    return fallback;
//  }

//  private readBoolean(row: MenuRow, keys: string[], fallback: boolean): boolean {
//    const value = this.readOptionalBoolean(row, keys);
//    return value ?? fallback;
//  }

//  private readOptionalBoolean(row: MenuRow, keys: string[]): boolean | null {
//    for (const key of keys) {
//      if (!(key in row)) {
//        continue;
//      }

//      const value = row[key];
//      if (typeof value === 'boolean') {
//        return value;
//      }

//      if (typeof value === 'number') {
//        return value === 1;
//      }

//      if (typeof value === 'string') {
//        return ['1', 'true', 'yes', 'y', 'active'].includes(value.trim().toLowerCase());
//      }
//    }

//    return null;
//  }

//  private toIconKey(value: string): string {
//    const normalized = value.toLowerCase().replace(/[^a-z0-9]+/g, '');
//    if (normalized.includes('dashboard') || normalized.includes('home')) {
//      return 'dashboard';
//    }
//    if (normalized.includes('account') || normalized.includes('manager') || normalized.includes('user')) {
//      return 'user';
//    }
//    if (normalized.includes('supervisor') || normalized.includes('eye') || normalized.includes('view')) {
//      return 'eye';
//    }
//    if (normalized.includes('supplier') || normalized.includes('truck') || normalized.includes('vendor')) {
//      return 'truck';
//    }
//    if (normalized.includes('customer') || normalized.includes('client')) {
//      return 'users';
//    }
//    if (normalized.includes('attendance') || normalized.includes('report')) {
//      return 'report';
//    }
//    if (normalized.includes('order') || normalized.includes('bill')) {
//      return 'order';
//    }

//    return 'menu';
//  }

//  private replacePlaceholder(url: string, key: string, value?: string): string {
//    return value ? url.replace(new RegExp(`\\{${key}\\}`, 'g'), encodeURIComponent(value)) : url;
//  }

//  private appendQueryParam(url: string, key: string, value: string): string {
//    const separator = url.includes('?') ? '&' : '?';
//    return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//  }

//  private hasPlaceholder(url: string, key: string): boolean {
//    return url.includes(`{${key}}`);
//  }

//  private withCacheBuster(url: string): string {
//    const separator = url.includes('?') ? '&' : '?';
//    return `${url}${separator}_=${Date.now()}`;
//  }

//  private isRecord(value: unknown): value is MenuRow {
//    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
//  }
//}




//import { Injectable } from '@angular/core';
//import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
//import { map } from 'rxjs/operators';
//import { BehaviorSubject, Observable, throwError } from 'rxjs';
//import { Menu } from '../../model/menu.model';
//import { CoreGymService } from '../../_services/core.gym.service.service';
//import { Guid } from '../../_helpers/guid';

//export type UserGroupUgid = string;

//export interface DashboardMenuRequest {
//  apiUrl: string;
//  productUId?: string;
//  userGroupUgid?: UserGroupUgid;
//  productParamName?: string;
//  ugidParamName?: string;
//}

//export interface DashboardMenuItem {
//  id: string;
//  label: string;
//  iconKey: string;
//  route?: string;
//  badge?: string;
//  hint?: string;
//  accentClass?: string;
//  dashboardGroup?: string;
//  showInDashboard?: boolean;
//  sortOrder: number;
//  section: string;
//  toastTitle?: string;
//  toastMessage?: string;
//}

//export interface DashboardMenuSection {
//  label: string;
//  sortOrder: number;
//  items: DashboardMenuItem[];
//}

//type MenuRow = Record<string, unknown>;

//@Injectable({
//  providedIn: 'root'
//})
//export class MenuService {
//  lostOfMenu: Array<Menu> = [];

//  private readonly ugidPattern = /^[A-Za-z0-9]{16}$/;
//  private menuList = new BehaviorSubject<Array<Menu>>(this.lostOfMenu);
//  getMenus = this.menuList.asObservable();

//  constructor(
//    private readonly http: HttpClient,
//    private readonly coreGymService: CoreGymService
//  ) { }

//  setmenu(menu: Array<Menu>): void {
//    const sortedMenu = [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//    this.menuList.next(sortedMenu);
//  }

//  mergeMenu(menu: Menu, action: string): Observable<Response> {
//    let httpheader = new HttpHeaders();
//    httpheader = httpheader.append('Content-Type', 'application/json');
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];

//    if (action === 'Edit' || action === 'Delete') {
//      url = url + '/' + menu.menuUId;
//      return this.http.put(url, JSON.stringify(menu), { headers: httpheader })
//        .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//    }

//    return this.http.post(url, JSON.stringify(menu), { headers: httpheader })
//      .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//  }

//  getMenu(): Observable<Array<Menu>>;
//  getMenu(menuUId: string): Observable<Array<Menu>>;
//  getMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]>;
//  getMenu(menuUIdOrRequest?: string | DashboardMenuRequest): Observable<Array<Menu> | DashboardMenuSection[]> {
//    if (menuUIdOrRequest && typeof menuUIdOrRequest === 'object') {
//      return this.getDashboardMenu(menuUIdOrRequest);
//    }

//    let url = this.coreGymService.BaseUrl!;
//    if (menuUIdOrRequest) {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUIdUrl'];
//      /*url = url.replace('{id}', menuUIdOrRequest || Guid.empty);*/
//      url = url.replace('{id}', String(menuUIdOrRequest || Guid.empty));
//      return this.http.get<Array<Menu>>(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//    }

//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  getMenuProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;

//    if (!productUId) {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//      return this.http.get<Array<Menu>>(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//    }

//    const ugid = (userGroupUgid || '').trim();
//    if (ugid && !this.ugidPattern.test(ugid)) {
//      return throwError(new Error('UGID must be exactly 16 alphanumeric characters.'));
//    }

//    url = url + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//    url = url.replace('{ProductUId}', productUId || Guid.empty);
//    url = url.replace('{RoleBasedMenus}', ugid || Guid.empty);
//    url = url.replace('{UGID}', ugid || Guid.empty);

//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//  }

//  deleteMenu(menuUId: Guid): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    url = url + '/' + menuUId;
//    return this.http.delete<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  getDashboardMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//    const ugid = request.userGroupUgid?.trim();
//    if (ugid && !this.ugidPattern.test(ugid)) {
//      return throwError(new Error('UGID must be exactly 16 alphanumeric characters.'));
//    }

//    return this.http
//      .get<unknown>(this.buildDashboardMenuUrl({ ...request, userGroupUgid: ugid }))
//      .pipe(map((response) => this.toDashboardSections(response)));
//  }

//  private buildDashboardMenuUrl(request: DashboardMenuRequest): string {
//    const productParamName = request.productParamName || 'ProductUId';
//    const ugidParamName = request.ugidParamName || 'RoleBasedMenus';
//    let url = request.apiUrl;

//    url = this.replacePlaceholder(url, productParamName, request.productUId);
//    url = this.replacePlaceholder(url, 'ProductUId', request.productUId);
//    url = this.replacePlaceholder(url, ugidParamName, request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'RoleBasedMenus', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UGID', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UserGroupUgid', request.userGroupUgid);

//    if (request.productUId && !this.hasPlaceholder(request.apiUrl, productParamName) && !this.hasPlaceholder(request.apiUrl, 'ProductUId')) {
//      url = this.appendQueryParam(url, productParamName, request.productUId);
//    }

//    if (
//      request.userGroupUgid &&
//      !this.hasPlaceholder(request.apiUrl, ugidParamName) &&
//      !this.hasPlaceholder(request.apiUrl, 'RoleBasedMenus') &&
//      !this.hasPlaceholder(request.apiUrl, 'UGID') &&
//      !this.hasPlaceholder(request.apiUrl, 'UserGroupUgid')
//    ) {
//      url = this.appendQueryParam(url, ugidParamName, request.userGroupUgid);
//    }

//    return this.withCacheBuster(url);
//  }

//  private toDashboardSections(response: unknown): DashboardMenuSection[] {
//    const rows = this.extractRows(response);
//    const activeRows = rows.filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true));
//    const sectionMap = new Map<string, DashboardMenuSection>();

//    activeRows.forEach((row, index) => {
//      const item = this.toDashboardMenuItem(row, index);
//      if (!item.label) {
//        return;
//      }

//      if (!sectionMap.has(item.section)) {
//        sectionMap.set(item.section, {
//          label: item.section,
//          sortOrder: this.readNumber(row, ['section_order', 'sectionOrder', 'group_order'], sectionMap.size + 1),
//          items: [],
//        });
//      }

//      sectionMap.get(item.section)?.items.push(item);
//    });

//    return Array.from(sectionMap.values())
//      .map((section) => ({
//        ...section,
//        items: section.items.sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label)),
//      }))
//      .sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label));
//  }

//  private toDashboardMenuItem(row: MenuRow, index: number): DashboardMenuItem {
//    const label = this.readString(row, ['title', 'Title', 'menu_name', 'menuName', 'MenuName', 'label', 'name']);
//    const section = this.readString(row, ['section', 'Section', 'section_name', 'sectionName', 'menu_group', 'menuGroup']) || 'Menu';
//    const route = this.readString(row, ['page', 'Page', 'route', 'routerLink', 'router_link', 'path', 'url']);
//    const iconValue = this.readString(row, ['icon', 'Icon', 'icon_key', 'iconKey', 'icon_name', 'iconName']);

//    return {
//      id: this.readString(row, ['menuUId', 'MenuUId', 'menu_id', 'menuId', 'id']) || `${section}-${label || index}`,
//      label,
//      section,
//      route,
//      iconKey: this.toIconKey(iconValue || label || section),
//      badge: this.readString(row, ['badgeValue', 'BadgeValue', 'badge', 'badge_count']),
//      hint: this.readString(row, ['description', 'hint', 'subtitle']),
//      sortOrder: this.readNumber(row, ['displayOrder', 'DisplayOrder', 'sort_order', 'sortOrder'], index + 1),
//      showInDashboard: this.readOptionalBoolean(row, ['show_on_dashboard', 'showOnDashboard']) ?? label.toLowerCase() !== 'dashboard',
//    };
//  }

//  private sortMenu(menu: Array<Menu>): Array<Menu> {
//    return [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//  }

//  private extractRows(response: unknown): MenuRow[] {
//    if (Array.isArray(response)) {
//      return response.filter(this.isRecord);
//    }

//    if (!this.isRecord(response)) {
//      return [];
//    }

//    const candidates = [response['data'], response['menus'], response['menu'], response['items'], response['rows'], response['result']];
//    for (const candidate of candidates) {
//      if (Array.isArray(candidate)) {
//        return candidate.filter(this.isRecord);
//      }
//    }

//    return [];
//  }

//  private readString(row: MenuRow, keys: string[]): string {
//    for (const key of keys) {
//      const value = row[key];
//      if (value !== undefined && value !== null && String(value).trim() !== '') {
//        return String(value).trim();
//      }
//    }

//    return '';
//  }

//  private readNumber(row: MenuRow, keys: string[], fallback: number): number {
//    for (const key of keys) {
//      const parsed = Number(row[key]);
//      if (Number.isFinite(parsed)) {
//        return parsed;
//      }
//    }

//    return fallback;
//  }

//  private readBoolean(row: MenuRow, keys: string[], fallback: boolean): boolean {
//    const value = this.readOptionalBoolean(row, keys);
//    return value ?? fallback;
//  }

//  private readOptionalBoolean(row: MenuRow, keys: string[]): boolean | null {
//    for (const key of keys) {
//      if (!(key in row)) {
//        continue;
//      }

//      const value = row[key];
//      if (typeof value === 'boolean') {
//        return value;
//      }

//      if (typeof value === 'number') {
//        return value === 1;
//      }

//      if (typeof value === 'string') {
//        return ['1', 'true', 'yes', 'y', 'active'].includes(value.trim().toLowerCase());
//      }
//    }

//    return null;
//  }

//  private toIconKey(value: string): string {
//    const normalized = value.toLowerCase().replace(/[^a-z0-9]+/g, '');
//    if (normalized.includes('dashboard') || normalized.includes('home')) {
//      return 'dashboard';
//    }
//    if (normalized.includes('account') || normalized.includes('manager') || normalized.includes('user')) {
//      return 'user';
//    }
//    if (normalized.includes('supervisor') || normalized.includes('eye') || normalized.includes('view')) {
//      return 'eye';
//    }
//    if (normalized.includes('supplier') || normalized.includes('truck') || normalized.includes('vendor')) {
//      return 'truck';
//    }
//    if (normalized.includes('customer') || normalized.includes('client')) {
//      return 'users';
//    }
//    if (normalized.includes('attendance') || normalized.includes('report')) {
//      return 'report';
//    }
//    if (normalized.includes('order') || normalized.includes('bill')) {
//      return 'order';
//    }

//    return 'menu';
//  }

//  private replacePlaceholder(url: string, key: string, value?: string): string {
//    return value ? url.replace(new RegExp(`\\{${key}\\}`, 'g'), encodeURIComponent(value)) : url;
//  }

//  private appendQueryParam(url: string, key: string, value: string): string {
//    const separator = url.includes('?') ? '&' : '?';
//    return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//  }

//  private hasPlaceholder(url: string, key: string): boolean {
//    return url.includes(`{${key}}`);
//  }

//  private withCacheBuster(url: string): string {
//    const separator = url.includes('?') ? '&' : '?';
//    return `${url}${separator}_=${Date.now()}`;
//  }

//  private isRecord(value: unknown): value is MenuRow {
//    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
//  }
//}







//import { Injectable } from '@angular/core';
//import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
//import { map } from 'rxjs/operators';
//import { BehaviorSubject, Observable, throwError } from 'rxjs';
//import { Menu } from '../../model/menu.model';
//import { CoreGymService } from '../../_services/core.gym.service.service';
//import { Guid } from '../../_helpers/guid';

//export type UserGroupUgid = string;

//export interface DashboardMenuRequest {
//  apiUrl: string;
//  productUId?: string;
//  userGroupUgid?: UserGroupUgid;
//  productParamName?: string;
//  ugidParamName?: string;
//}

//export interface DashboardMenuItem {
//  id: string;
//  label: string;
//  iconKey: string;
//  route?: string;
//  badge?: string;
//  hint?: string;
//  accentClass?: string;
//  dashboardGroup?: string;
//  showInDashboard?: boolean;
//  sortOrder: number;
//  section: string;
//  toastTitle?: string;
//  toastMessage?: string;
//}

//export interface DashboardMenuSection {
//  label: string;
//  sortOrder: number;
//  items: DashboardMenuItem[];
//}

//type MenuRow = Record<string, unknown>;

//@Injectable({
//  providedIn: 'root'
//})
//export class MenuService {
//  lostOfMenu: Array<Menu> = [];

//  private menuList = new BehaviorSubject<Array<Menu>>(this.lostOfMenu);
//  menus$ = this.menuList.asObservable();

//  constructor(
//    private readonly http: HttpClient,
//    private readonly coreGymService: CoreGymService
//  ) { }

//  setmenu(menu: Array<Menu>): void {
//    const sortedMenu = [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//    this.menuList.next(sortedMenu);
//  }

//  mergeMenu(menu: Menu, action: string): Observable<Response> {
//    let httpheader = new HttpHeaders();
//    httpheader = httpheader.append('Content-Type', 'application/json');
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];

//    if (action === 'Edit' || action === 'Delete') {
//      url = url + '/' + menu.menuUId;
//      return this.http.put(url, JSON.stringify(menu), { headers: httpheader })
//        .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//    }

//    return this.http.post(url, JSON.stringify(menu), { headers: httpheader })
//      .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//  }

//  getMenus(): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  getMenuById(menuUId: string): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUIdUrl'];
//    url = url.replace('{id}', menuUId || Guid.empty);
//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  getDashboardMenus(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//    return this.getDashboardMenu(request);
//  }

//  getDashboardMenusProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<DashboardMenuSection[]> {
//    if (!productUId) {
//      return throwError(new Error('ProductUId is required to load dashboard menus.'));
//    }

//    const url = this.coreGymService.BaseUrl! + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//    return this.getDashboardMenu({
//      apiUrl: url,
//      productUId,
//      userGroupUgid: this.sanitizeUgid(userGroupUgid),
//      productParamName: 'ProductUId',
//      ugidParamName: 'RoleBasedMenus',
//    });
//  }

//  // Backward-compatible wrapper for older screens. New code should use getMenus, getMenuById, or getDashboardMenus.
//  getMenu(): Observable<Array<Menu>>;
//  getMenu(menuUId: string): Observable<Array<Menu>>;
//  getMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]>;
//  getMenu(menuUIdOrRequest?: string | DashboardMenuRequest): Observable<Array<Menu> | DashboardMenuSection[]> {
//    if (menuUIdOrRequest && typeof menuUIdOrRequest === 'object') {
//      return this.getDashboardMenus(menuUIdOrRequest);
//    }

//    if (menuUIdOrRequest) {
//      return this.getMenuById(menuUIdOrRequest.toString());
//    }

//    return this.getMenus();
//  }

//  getMenuProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;

//    if (!productUId) {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//      return this.http.get<Array<Menu>>(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//    }

//    // UGID format validation is handled by the backend. Whatever the user has
//    // stored locally (GUID, role-id, etc.) is passed through as-is, and an
//    // empty value falls back to Guid.empty so the URL remains well-formed.
//    const ugid = this.sanitizeUgid(userGroupUgid);

//    url = url + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//    url = url.replace('{ProductUId}', productUId || Guid.empty);
//    url = url.replace('{RoleBasedMenus}', ugid || Guid.empty);
//    url = url.replace('{UGID}', ugid || Guid.empty);

//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//  }

//  deleteMenu(menuUId: Guid): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    url = url + '/' + menuUId;
//    return this.http.delete<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  private getDashboardMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//    // No client-side UGID format check — the API is the source of truth for
//    // what's valid. Empty / null / whitespace values are dropped cleanly so
//    // they don't end up in the query string.
//    const sanitizedRequest: DashboardMenuRequest = {
//      ...request,
//      userGroupUgid: this.sanitizeUgid(request.userGroupUgid),
//    };

//    return this.http
//      .get<unknown>(this.buildDashboardMenuUrl(sanitizedRequest))
//      .pipe(map((response) => this.toDashboardSections(response)));
//  }

//  private buildDashboardMenuUrl(request: DashboardMenuRequest): string {
//    const productParamName = request.productParamName || 'ProductUId';
//    const ugidParamName = request.ugidParamName || 'RoleBasedMenus';
//    let url = request.apiUrl;

//    url = this.replacePlaceholder(url, productParamName, request.productUId);
//    url = this.replacePlaceholder(url, 'ProductUId', request.productUId);
//    url = this.replacePlaceholder(url, ugidParamName, request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'RoleBasedMenus', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UGID', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UserGroupUgid', request.userGroupUgid);

//    if (request.productUId && !this.hasPlaceholder(request.apiUrl, productParamName) && !this.hasPlaceholder(request.apiUrl, 'ProductUId')) {
//      url = this.appendQueryParam(url, productParamName, request.productUId);
//    }

//    if (
//      request.userGroupUgid &&
//      !this.hasPlaceholder(request.apiUrl, ugidParamName) &&
//      !this.hasPlaceholder(request.apiUrl, 'RoleBasedMenus') &&
//      !this.hasPlaceholder(request.apiUrl, 'UGID') &&
//      !this.hasPlaceholder(request.apiUrl, 'UserGroupUgid')
//    ) {
//      url = this.appendQueryParam(url, ugidParamName, request.userGroupUgid);
//    }

//    return this.withCacheBuster(url);
//  }

//  private toDashboardSections(response: unknown): DashboardMenuSection[] {
//    const rows = this.extractRows(response);
//    const activeRows = rows.filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true));
//    const sectionMap = new Map<string, DashboardMenuSection>();

//    activeRows.forEach((row, index) => {
//      const item = this.toDashboardMenuItem(row, index);
//      if (!item.label) {
//        return;
//      }

//      if (!sectionMap.has(item.section)) {
//        sectionMap.set(item.section, {
//          label: item.section,
//          sortOrder: this.readNumber(row, ['section_order', 'sectionOrder', 'group_order'], sectionMap.size + 1),
//          items: [],
//        });
//      }

//      sectionMap.get(item.section)?.items.push(item);
//    });

//    return Array.from(sectionMap.values())
//      .map((section) => ({
//        ...section,
//        items: section.items.sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label)),
//      }))
//      .sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label));
//  }

//  private toDashboardMenuItem(row: MenuRow, index: number): DashboardMenuItem {
//    const label = this.readString(row, ['title', 'Title', 'menu_name', 'menuName', 'MenuName', 'label', 'name']);
//    const section = this.readString(row, ['section', 'Section', 'section_name', 'sectionName', 'menu_group', 'menuGroup']) || 'Menu';
//    const route = this.readString(row, ['page', 'Page', 'route', 'routerLink', 'router_link', 'path', 'url']);
//    const iconValue = this.readString(row, ['icon', 'Icon', 'icon_key', 'iconKey', 'icon_name', 'iconName']);

//    return {
//      id: this.readString(row, ['menuUId', 'MenuUId', 'menu_id', 'menuId', 'id']) || `${section}-${label || index}`,
//      label,
//      section,
//      route,
//      iconKey: this.toIconKey(iconValue || label || section),
//      badge: this.readString(row, ['badgeValue', 'BadgeValue', 'badge', 'badge_count']),
//      hint: this.readString(row, ['description', 'hint', 'subtitle']),
//      sortOrder: this.readNumber(row, ['displayOrder', 'DisplayOrder', 'sort_order', 'sortOrder'], index + 1),
//      showInDashboard: this.readOptionalBoolean(row, ['show_on_dashboard', 'showOnDashboard']) ?? label.toLowerCase() !== 'dashboard',
//    };
//  }

//  private sortMenu(menu: Array<Menu>): Array<Menu> {
//    return [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//  }

//  private extractRows(response: unknown): MenuRow[] {
//    if (Array.isArray(response)) {
//      return response.filter(this.isRecord);
//    }

//    if (!this.isRecord(response)) {
//      return [];
//    }

//    const candidates = [response['data'], response['menus'], response['menu'], response['items'], response['rows'], response['result']];
//    for (const candidate of candidates) {
//      if (Array.isArray(candidate)) {
//        return candidate.filter(this.isRecord);
//      }
//    }

//    return [];
//  }

//  private readString(row: MenuRow, keys: string[]): string {
//    for (const key of keys) {
//      const value = row[key];
//      if (value !== undefined && value !== null && String(value).trim() !== '') {
//        return String(value).trim();
//      }
//    }

//    return '';
//  }

//  private readNumber(row: MenuRow, keys: string[], fallback: number): number {
//    for (const key of keys) {
//      const parsed = Number(row[key]);
//      if (Number.isFinite(parsed)) {
//        return parsed;
//      }
//    }

//    return fallback;
//  }

//  private readBoolean(row: MenuRow, keys: string[], fallback: boolean): boolean {
//    const value = this.readOptionalBoolean(row, keys);
//    return value ?? fallback;
//  }

//  private readOptionalBoolean(row: MenuRow, keys: string[]): boolean | null {
//    for (const key of keys) {
//      if (!(key in row)) {
//        continue;
//      }

//      const value = row[key];
//      if (typeof value === 'boolean') {
//        return value;
//      }

//      if (typeof value === 'number') {
//        return value === 1;
//      }

//      if (typeof value === 'string') {
//        return ['1', 'true', 'yes', 'y', 'active'].includes(value.trim().toLowerCase());
//      }
//    }

//    return null;
//  }

//  private toIconKey(value: string): string {
//    const normalized = value.toLowerCase().replace(/[^a-z0-9]+/g, '');
//    if (normalized.includes('dashboard') || normalized.includes('home')) {
//      return 'dashboard';
//    }
//    if (normalized.includes('account') || normalized.includes('manager') || normalized.includes('user')) {
//      return 'user';
//    }
//    if (normalized.includes('supervisor') || normalized.includes('eye') || normalized.includes('view')) {
//      return 'eye';
//    }
//    if (normalized.includes('supplier') || normalized.includes('truck') || normalized.includes('vendor')) {
//      return 'truck';
//    }
//    if (normalized.includes('customer') || normalized.includes('client')) {
//      return 'users';
//    }
//    if (normalized.includes('attendance') || normalized.includes('report')) {
//      return 'report';
//    }
//    if (normalized.includes('order') || normalized.includes('bill')) {
//      return 'order';
//    }

//    return 'menu';
//  }

//  /**
//   * Normalises a UGID-like value coming from localStorage / callers.
//   * Returns an empty string for null, undefined, whitespace-only, or the
//   * literal strings 'null' / 'undefined' (which can sneak in via storage).
//   * Any other value is returned trimmed and passed through to the API.
//   */
//  private sanitizeUgid(value?: UserGroupUgid | null): string {
//    if (value === null || value === undefined) {
//      return '';
//    }

//    const trimmed = String(value).trim();
//    if (!trimmed || trimmed.toLowerCase() === 'null' || trimmed.toLowerCase() === 'undefined') {
//      return '';
//    }

//    return trimmed;
//  }

//  private replacePlaceholder(url: string, key: string, value?: string): string {
//    return value ? url.replace(new RegExp(`\\{${key}\\}`, 'g'), encodeURIComponent(value)) : url;
//  }

//  private appendQueryParam(url: string, key: string, value: string): string {
//    const separator = url.includes('?') ? '&' : '?';
//    return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//  }

//  private hasPlaceholder(url: string, key: string): boolean {
//    return url.includes(`{${key}}`);
//  }

//  private withCacheBuster(url: string): string {
//    const separator = url.includes('?') ? '&' : '?';
//    return `${url}${separator}_=${Date.now()}`;
//  }

//  private isRecord(value: unknown): value is MenuRow {
//    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
//  }
//}





//import { Injectable } from '@angular/core';
//import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
//import { map } from 'rxjs/operators';
//import { BehaviorSubject, Observable, throwError } from 'rxjs';
//import { Menu } from '../../model/menu.model';
//import { CoreGymService } from '../../_services/core.gym.service.service';
//import { Guid } from '../../_helpers/guid';

//export type UserGroupUgid = string;

//export interface DashboardMenuRequest {
//  apiUrl: string;
//  productUId?: string;
//  userGroupUgid?: UserGroupUgid;
//  productParamName?: string;
//  ugidParamName?: string;
//}

//export interface DashboardMenuItem {
//  id: string;
//  label: string;
//  iconKey: string;
//  route?: string;
//  badge?: string;
//  hint?: string;
//  accentClass?: string;
//  dashboardGroup?: string;
//  showInDashboard?: boolean;
//  sortOrder: number;
//  section: string;
//  toastTitle?: string;
//  toastMessage?: string;
//}

//export interface DashboardMenuSection {
//  label: string;
//  sortOrder: number;
//  items: DashboardMenuItem[];
//}

//type MenuRow = Record<string, unknown>;

//@Injectable({
//  providedIn: 'root'
//})
//export class MenuService {
//  lostOfMenu: Array<Menu> = [];

//  private menuList = new BehaviorSubject<Array<Menu>>(this.lostOfMenu);
//  menus$ = this.menuList.asObservable();

//  constructor(
//    private readonly http: HttpClient,
//    private readonly coreGymService: CoreGymService
//  ) { }

//  setmenu(menu: Array<Menu>): void {
//    const sortedMenu = [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//    this.menuList.next(sortedMenu);
//  }

//  mergeMenu(menu: Menu, action: string): Observable<Response> {
//    let httpheader = new HttpHeaders();
//    httpheader = httpheader.append('Content-Type', 'application/json');
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];

//    if (action === 'Edit' || action === 'Delete') {
//      url = url + '/' + menu.menuUId;
//      return this.http.put(url, JSON.stringify(menu), { headers: httpheader })
//        .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//    }

//    return this.http.post(url, JSON.stringify(menu), { headers: httpheader })
//      .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//  }

//  getMenus(): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  getMenuById(menuUId: string): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUIdUrl'];
//    url = url.replace('{id}', menuUId || Guid.empty);
//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  getDashboardMenus(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//    return this.getDashboardMenu(request);
//  }

//  getDashboardMenusProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<DashboardMenuSection[]> {
//    if (!productUId) {
//      return throwError(new Error('ProductUId is required to load dashboard menus.'));
//    }

//    const url = this.coreGymService.BaseUrl! + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//    return this.getDashboardMenu({
//      apiUrl: url,
//      productUId,
//      userGroupUgid: this.sanitizeUgid(userGroupUgid),
//      productParamName: 'ProductUId',
//      ugidParamName: 'RoleBasedMenus',
//    });
//  }

//  // Backward-compatible wrapper for older screens. New code should use getMenus, getMenuById, or getDashboardMenus.
//  getMenu(): Observable<Array<Menu>>;
//  getMenu(menuUId: string): Observable<Array<Menu>>;
//  getMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]>;
//  getMenu(menuUIdOrRequest?: string | DashboardMenuRequest): Observable<Array<Menu> | DashboardMenuSection[]> {
//    if (menuUIdOrRequest && typeof menuUIdOrRequest === 'object') {
//      return this.getDashboardMenus(menuUIdOrRequest);
//    }

//    if (menuUIdOrRequest) {
//      return this.getMenuById(menuUIdOrRequest.toString());
//    }

//    return this.getMenus();
//  }

//  getMenuProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;

//    if (!productUId) {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//      return this.http.get<Array<Menu>>(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//    }

//    // UGID format validation is handled by the backend. Whatever the user has
//    // stored locally (GUID, role-id, etc.) is passed through as-is, and an
//    // empty value falls back to Guid.empty so the URL remains well-formed.
//    const ugid = this.sanitizeUgid(userGroupUgid);

//    url = url + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//    url = url.replace('{ProductUId}', productUId || Guid.empty);
//    url = url.replace('{RoleBasedMenus}', ugid || Guid.empty);
//    url = url.replace('{UGID}', ugid || Guid.empty);

//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//  }

//  deleteMenu(menuUId: Guid): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    url = url + '/' + menuUId;
//    return this.http.delete<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  private getDashboardMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//    // No client-side UGID format check — the API is the source of truth for
//    // what's valid. Empty / null / whitespace values are dropped cleanly so
//    // they don't end up in the query string.
//    const sanitizedRequest: DashboardMenuRequest = {
//      ...request,
//      userGroupUgid: this.sanitizeUgid(request.userGroupUgid),
//    };

//    return this.http
//      .get<unknown>(this.buildDashboardMenuUrl(sanitizedRequest))
//      .pipe(map((response) => this.toDashboardSections(response)));
//  }

//  private buildDashboardMenuUrl(request: DashboardMenuRequest): string {
//    const productParamName = request.productParamName || 'ProductUId';
//    const ugidParamName = request.ugidParamName || 'RoleBasedMenus';
//    let url = request.apiUrl;

//    url = this.replacePlaceholder(url, productParamName, request.productUId);
//    url = this.replacePlaceholder(url, 'ProductUId', request.productUId);
//    url = this.replacePlaceholder(url, ugidParamName, request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'RoleBasedMenus', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UGID', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UserGroupUgid', request.userGroupUgid);

//    if (request.productUId && !this.hasPlaceholder(request.apiUrl, productParamName) && !this.hasPlaceholder(request.apiUrl, 'ProductUId')) {
//      url = this.appendQueryParam(url, productParamName, request.productUId);
//    }

//    if (
//      request.userGroupUgid &&
//      !this.hasPlaceholder(request.apiUrl, ugidParamName) &&
//      !this.hasPlaceholder(request.apiUrl, 'RoleBasedMenus') &&
//      !this.hasPlaceholder(request.apiUrl, 'UGID') &&
//      !this.hasPlaceholder(request.apiUrl, 'UserGroupUgid')
//    ) {
//      url = this.appendQueryParam(url, ugidParamName, request.userGroupUgid);
//    }

//    return this.withCacheBuster(url);
//  }

//  private toDashboardSections(response: unknown): DashboardMenuSection[] {
//    const rows = this.extractRows(response);
//    const activeRows = rows.filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true));
//    const sectionMap = new Map<string, DashboardMenuSection>();

//    activeRows.forEach((row, index) => {
//      const item = this.toDashboardMenuItem(row, index);
//      if (!item.label) {
//        return;
//      }

//      if (!sectionMap.has(item.section)) {
//        sectionMap.set(item.section, {
//          label: item.section,
//          sortOrder: this.readNumber(row, ['section_order', 'sectionOrder', 'group_order'], sectionMap.size + 1),
//          items: [],
//        });
//      }

//      sectionMap.get(item.section)?.items.push(item);
//    });

//    return Array.from(sectionMap.values())
//      .map((section) => ({
//        ...section,
//        items: section.items.sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label)),
//      }))
//      .sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label));
//  }

//  private toDashboardMenuItem(row: MenuRow, index: number): DashboardMenuItem {
//    const label = this.readString(row, ['title', 'Title', 'menu_name', 'menuName', 'MenuName', 'label', 'name']);
//    const section = this.readString(row, ['section', 'Section', 'section_name', 'sectionName', 'menu_group', 'menuGroup']) || 'Menu';
//    const route = this.readString(row, ['page', 'Page', 'route', 'routerLink', 'router_link', 'path', 'url']);
//    const iconValue = this.readString(row, ['icon', 'Icon', 'icon_key', 'iconKey', 'icon_name', 'iconName']);

//    return {
//      id: this.readString(row, ['menuUId', 'MenuUId', 'menu_id', 'menuId', 'id']) || `${section}-${label || index}`,
//      label,
//      section,
//      route,
//      iconKey: this.toIconKey(iconValue || label || section),
//      badge: this.readString(row, ['badgeValue', 'BadgeValue', 'badge', 'badge_count']),
//      hint: this.readString(row, ['description', 'hint', 'subtitle']),
//      sortOrder: this.readNumber(row, ['displayOrder', 'DisplayOrder', 'sort_order', 'sortOrder'], index + 1),
//      showInDashboard: this.readOptionalBoolean(row, ['show_on_dashboard', 'showOnDashboard']) ?? label.toLowerCase() !== 'dashboard',
//    };
//  }

//  private sortMenu(menu: Array<Menu>): Array<Menu> {
//    return [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//  }

//  private extractRows(response: unknown): MenuRow[] {
//    if (Array.isArray(response)) {
//      return response.filter(this.isRecord);
//    }

//    if (!this.isRecord(response)) {
//      return [];
//    }

//    const candidates = [response['data'], response['menus'], response['menu'], response['items'], response['rows'], response['result']];
//    for (const candidate of candidates) {
//      if (Array.isArray(candidate)) {
//        return candidate.filter(this.isRecord);
//      }
//    }

//    return [];
//  }

//  private readString(row: MenuRow, keys: string[]): string {
//    for (const key of keys) {
//      const value = row[key];
//      if (value !== undefined && value !== null && String(value).trim() !== '') {
//        return String(value).trim();
//      }
//    }

//    return '';
//  }

//  private readNumber(row: MenuRow, keys: string[], fallback: number): number {
//    for (const key of keys) {
//      const parsed = Number(row[key]);
//      if (Number.isFinite(parsed)) {
//        return parsed;
//      }
//    }

//    return fallback;
//  }

//  private readBoolean(row: MenuRow, keys: string[], fallback: boolean): boolean {
//    const value = this.readOptionalBoolean(row, keys);
//    return value ?? fallback;
//  }

//  private readOptionalBoolean(row: MenuRow, keys: string[]): boolean | null {
//    for (const key of keys) {
//      if (!(key in row)) {
//        continue;
//      }

//      const value = row[key];
//      if (typeof value === 'boolean') {
//        return value;
//      }

//      if (typeof value === 'number') {
//        return value === 1;
//      }

//      if (typeof value === 'string') {
//        return ['1', 'true', 'yes', 'y', 'active'].includes(value.trim().toLowerCase());
//      }
//    }

//    return null;
//  }

//  private toIconKey(value: string): string {
//    const normalized = value.toLowerCase().replace(/[^a-z0-9]+/g, '');
//    if (normalized.includes('dashboard') || normalized.includes('home')) {
//      return 'dashboard';
//    }
//    if (normalized.includes('account') || normalized.includes('manager') || normalized.includes('user')) {
//      return 'user';
//    }
//    if (normalized.includes('supervisor') || normalized.includes('eye') || normalized.includes('view')) {
//      return 'eye';
//    }
//    if (normalized.includes('supplier') || normalized.includes('truck') || normalized.includes('vendor')) {
//      return 'truck';
//    }
//    if (normalized.includes('customer') || normalized.includes('client')) {
//      return 'users';
//    }
//    if (normalized.includes('attendance') || normalized.includes('report')) {
//      return 'report';
//    }
//    if (normalized.includes('order') || normalized.includes('bill')) {
//      return 'order';
//    }

//    return 'menu';
//  }

//  /**
//   * Normalises a UGID-like value coming from localStorage / callers.
//   * Returns an empty string for null, undefined, whitespace-only, or the
//   * literal strings 'null' / 'undefined' (which can sneak in via storage).
//   * Any other value is returned trimmed and passed through to the API.
//   */
//  private sanitizeUgid(value?: UserGroupUgid | null): string {
//    if (value === null || value === undefined) {
//      return '';
//    }

//    const trimmed = String(value).trim();
//    if (!trimmed || trimmed.toLowerCase() === 'null' || trimmed.toLowerCase() === 'undefined') {
//      return '';
//    }

//    return trimmed;
//  }

//  private replacePlaceholder(url: string, key: string, value?: string): string {
//    return value ? url.replace(new RegExp(`\\{${key}\\}`, 'g'), encodeURIComponent(value)) : url;
//  }

//  private appendQueryParam(url: string, key: string, value: string): string {
//    const separator = url.includes('?') ? '&' : '?';
//    return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//  }

//  private hasPlaceholder(url: string, key: string): boolean {
//    return url.includes(`{${key}}`);
//  }

//  private withCacheBuster(url: string): string {
//    const separator = url.includes('?') ? '&' : '?';
//    return `${url}${separator}_=${Date.now()}`;
//  }

//  private isRecord(value: unknown): value is MenuRow {
//    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
//  }
//}






//import { Injectable } from '@angular/core';
//import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
//import { map } from 'rxjs/operators';
//import { BehaviorSubject, Observable, throwError } from 'rxjs';
//import { Menu } from '../../model/menu.model';
//import { CoreGymService } from '../../_services/core.gym.service.service';
//import { Guid } from '../../_helpers/guid';

//export type UserGroupUgid = string;

//export interface DashboardMenuRequest {
//  apiUrl: string;
//  productUId?: string;
//  userGroupUgid?: UserGroupUgid;
//  productParamName?: string;
//  ugidParamName?: string;
//}

//export interface DashboardMenuItem {
//  id: string;
//  label: string;
//  iconKey: string;
//  route?: string;
//  badge?: string;
//  hint?: string;
//  accentClass?: string;
//  dashboardGroup?: string;
//  showInDashboard?: boolean;
//  sortOrder: number;
//  section: string;
//  toastTitle?: string;
//  toastMessage?: string;
//}

//export interface DashboardMenuSection {
//  label: string;
//  sortOrder: number;
//  items: DashboardMenuItem[];
//}

//type MenuRow = Record<string, unknown>;

//// ─── Section inference ─────────────────────────────────────────
//// Used when the API doesn't return a usable `Section` value for a row.
//// We map menu labels / routes to one of these canonical sections and
//// give each section a stable sort order so the sidebar always groups
//// the same way regardless of row order.
//const SECTION_ORDER: Record<string, number> = {
//  'Main': 10,
//  'Account & Management': 20,
//  'Registration': 30,
//  'Customer Management': 40,
//  'Product Management': 50,
//  'Orders': 60,
//  'Payments': 70,
//  'Billing & Invoices': 80,
//  'Attendance & Reports': 90,
//  'Configuration': 100,
//  'Menu': 999,
//};

//@Injectable({
//  providedIn: 'root'
//})
//export class MenuService {
//  lostOfMenu: Array<Menu> = [];

//  private menuList = new BehaviorSubject<Array<Menu>>(this.lostOfMenu);
//  menus$ = this.menuList.asObservable();

//  constructor(
//    private readonly http: HttpClient,
//    private readonly coreGymService: CoreGymService
//  ) { }

//  setmenu(menu: Array<Menu>): void {
//    const sortedMenu = [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//    this.menuList.next(sortedMenu);
//  }

//  mergeMenu(menu: Menu, action: string): Observable<Response> {
//    let httpheader = new HttpHeaders();
//    httpheader = httpheader.append('Content-Type', 'application/json');
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];

//    if (action === 'Edit' || action === 'Delete') {
//      url = url + '/' + menu.menuUId;
//      return this.http.put(url, JSON.stringify(menu), { headers: httpheader })
//        .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//    }

//    return this.http.post(url, JSON.stringify(menu), { headers: httpheader })
//      .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//  }

//  getMenus(): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  getMenuById(menuUId: string): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUIdUrl'];
//    url = url.replace('{id}', menuUId || Guid.empty);
//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  getDashboardMenus(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//    return this.getDashboardMenu(request);
//  }

//  getDashboardMenusProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<DashboardMenuSection[]> {
//    if (!productUId) {
//      return throwError(new Error('ProductUId is required to load dashboard menus.'));
//    }

//    const url = this.coreGymService.BaseUrl! + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//    return this.getDashboardMenu({
//      apiUrl: url,
//      productUId,
//      userGroupUgid: this.sanitizeUgid(userGroupUgid),
//      productParamName: 'ProductUId',
//      ugidParamName: 'RoleBasedMenus',
//    });
//  }

//  getMenu(): Observable<Array<Menu>>;
//  getMenu(menuUId: string): Observable<Array<Menu>>;
//  getMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]>;
//  getMenu(menuUIdOrRequest?: string | DashboardMenuRequest): Observable<Array<Menu> | DashboardMenuSection[]> {
//    if (menuUIdOrRequest && typeof menuUIdOrRequest === 'object') {
//      return this.getDashboardMenus(menuUIdOrRequest);
//    }
//    if (menuUIdOrRequest) {
//      return this.getMenuById(menuUIdOrRequest.toString());
//    }
//    return this.getMenus();
//  }

//  getMenuProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    if (!productUId) {
//      url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//      return this.http.get<Array<Menu>>(url)
//        .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//    }

//    const ugid = this.sanitizeUgid(userGroupUgid);
//    url = url + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//    url = url.replace('{ProductUId}', productUId || Guid.empty);
//    url = url.replace('{RoleBasedMenus}', ugid || Guid.empty);
//    url = url.replace('{UGID}', ugid || Guid.empty);

//    return this.http.get<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//  }

//  deleteMenu(menuUId: Guid): Observable<Array<Menu>> {
//    let url = this.coreGymService.BaseUrl!;
//    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//    url = url + '/' + menuUId;
//    return this.http.delete<Array<Menu>>(url)
//      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//  }

//  private getDashboardMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//    const sanitizedRequest: DashboardMenuRequest = {
//      ...request,
//      userGroupUgid: this.sanitizeUgid(request.userGroupUgid),
//    };
//    return this.http
//      .get<unknown>(this.buildDashboardMenuUrl(sanitizedRequest))
//      .pipe(map((response) => this.toDashboardSections(response)));
//  }

//  private buildDashboardMenuUrl(request: DashboardMenuRequest): string {
//    const productParamName = request.productParamName || 'ProductUId';
//    const ugidParamName = request.ugidParamName || 'RoleBasedMenus';
//    let url = request.apiUrl;

//    url = this.replacePlaceholder(url, productParamName, request.productUId);
//    url = this.replacePlaceholder(url, 'ProductUId', request.productUId);
//    url = this.replacePlaceholder(url, ugidParamName, request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'RoleBasedMenus', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UGID', request.userGroupUgid);
//    url = this.replacePlaceholder(url, 'UserGroupUgid', request.userGroupUgid);

//    if (request.productUId && !this.hasPlaceholder(request.apiUrl, productParamName) && !this.hasPlaceholder(request.apiUrl, 'ProductUId')) {
//      url = this.appendQueryParam(url, productParamName, request.productUId);
//    }
//    if (request.userGroupUgid &&
//      !this.hasPlaceholder(request.apiUrl, ugidParamName) &&
//      !this.hasPlaceholder(request.apiUrl, 'RoleBasedMenus') &&
//      !this.hasPlaceholder(request.apiUrl, 'UGID') &&
//      !this.hasPlaceholder(request.apiUrl, 'UserGroupUgid')) {
//      url = this.appendQueryParam(url, ugidParamName, request.userGroupUgid);
//    }
//    return this.withCacheBuster(url);
//  }

//  private toDashboardSections(response: unknown): DashboardMenuSection[] {
//    const rows = this.extractRows(response);
//    const activeRows = rows.filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true));
//    const sectionMap = new Map<string, DashboardMenuSection>();

//    activeRows.forEach((row, index) => {
//      const item = this.toDashboardMenuItem(row, index);
//      if (!item.label) return;

//      if (!sectionMap.has(item.section)) {
//        sectionMap.set(item.section, {
//          label: item.section,
//          sortOrder: SECTION_ORDER[item.section] ??
//            this.readNumber(row, ['section_order', 'sectionOrder', 'group_order'], 500 + sectionMap.size),
//          items: [],
//        });
//      }
//      sectionMap.get(item.section)?.items.push(item);
//    });

//    return Array.from(sectionMap.values())
//      .map((s) => ({ ...s, items: s.items.sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label)) }))
//      .sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label));
//  }

//  private toDashboardMenuItem(row: MenuRow, index: number): DashboardMenuItem {
//    const label = this.readString(row, ['title', 'Title', 'menu_name', 'menuName', 'MenuName', 'label', 'name']);
//    const route = this.readString(row, ['page', 'Page', 'route', 'routerLink', 'router_link', 'path', 'url']);
//    const rawIcon = this.readString(row, ['icon', 'Icon', 'icon_key', 'iconKey', 'icon_name', 'iconName']);
//    const apiSect = this.readString(row, ['section', 'Section', 'section_name', 'sectionName', 'menu_group', 'menuGroup']);
//    const section = this.resolveSection(apiSect, label, route);

//    return {
//      id: this.readString(row, ['menuUId', 'MenuUId', 'menu_id', 'menuId', 'id']) || `${section}-${label || index}`,
//      label,
//      section,
//      route,
//      iconKey: this.toIconKey(rawIcon || label || section),
//      badge: this.readString(row, ['badgeValue', 'BadgeValue', 'badge', 'badge_count']),
//      hint: this.readString(row, ['description', 'hint', 'subtitle']),
//      sortOrder: this.readNumber(row, ['displayOrder', 'DisplayOrder', 'sort_order', 'sortOrder'], index + 1),
//      showInDashboard: this.readOptionalBoolean(row, ['show_on_dashboard', 'showOnDashboard']) ?? label.toLowerCase() !== 'dashboard',
//    };
//  }

//  /**
//   * Picks the section a menu row belongs to.
//   *
//   * If the API gives us a real-looking section name (not "Menu", "MENU",
//   * "Default", or empty), we trust it. Otherwise we infer from the label
//   * and route using keyword matching, so existing menu tables that don't
//   * have section columns still produce a properly grouped sidebar.
//   */
//  private resolveSection(apiSection: string, label: string, route: string): string {
//    const trimmed = (apiSection || '').trim();
//    const lower = trimmed.toLowerCase();
//    const isPlaceholder = !trimmed || lower === 'menu' || lower === 'default' || lower === 'main menu' || lower === 'navigation';
//    if (!isPlaceholder) {
//      return trimmed;
//    }
//    return this.inferSection(label, route);
//  }

//  private inferSection(label: string, route: string): string {
//    const haystack = `${label} ${route}`.toLowerCase();
//    const has = (...needles: string[]) => needles.some((n) => haystack.includes(n));

//    if (has('dashboard', 'home', 'overview')) return 'Main';
//    if (has('account creation', 'accountcreation', 'account')) return 'Account & Management';
//    if (has('manager', 'supervisor', 'supplier', 'staff', 'employee')) return 'Registration';
//    if (has('customer', 'client', 'guest')) return 'Customer Management';
//    if (has('product', 'store', 'inventory', 'stock', 'item')) return 'Product Management';
//    if (has('order')) return 'Orders';
//    if (has('payment', 'receipt')) return 'Payments';
//    if (has('invoice', 'bill')) return 'Billing & Invoices';
//    if (has('attendance', 'report')) return 'Attendance & Reports';
//    if (has('tax', 'setup', 'setting', 'config', 'master')) return 'Configuration';

//    return 'Menu';
//  }

//  private sortMenu(menu: Array<Menu>): Array<Menu> {
//    return [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//  }

//  private extractRows(response: unknown): MenuRow[] {
//    if (Array.isArray(response)) return response.filter(this.isRecord);
//    if (!this.isRecord(response)) return [];
//    const candidates = [response['data'], response['menus'], response['menu'], response['items'], response['rows'], response['result']];
//    for (const c of candidates) if (Array.isArray(c)) return c.filter(this.isRecord);
//    return [];
//  }

//  private readString(row: MenuRow, keys: string[]): string {
//    for (const key of keys) {
//      const value = row[key];
//      if (value !== undefined && value !== null && String(value).trim() !== '') return String(value).trim();
//    }
//    return '';
//  }

//  private readNumber(row: MenuRow, keys: string[], fallback: number): number {
//    for (const key of keys) {
//      const parsed = Number(row[key]);
//      if (Number.isFinite(parsed)) return parsed;
//    }
//    return fallback;
//  }

//  private readBoolean(row: MenuRow, keys: string[], fallback: boolean): boolean {
//    const v = this.readOptionalBoolean(row, keys);
//    return v ?? fallback;
//  }

//  private readOptionalBoolean(row: MenuRow, keys: string[]): boolean | null {
//    for (const key of keys) {
//      if (!(key in row)) continue;
//      const v = row[key];
//      if (typeof v === 'boolean') return v;
//      if (typeof v === 'number') return v === 1;
//      if (typeof v === 'string') return ['1', 'true', 'yes', 'y', 'active'].includes(v.trim().toLowerCase());
//    }
//    return null;
//  }

//  private toIconKey(value: string): string {
//    const n = value.toLowerCase().replace(/[^a-z0-9]+/g, '');
//    if (n.includes('dashboard') || n.includes('home')) return 'dashboard';
//    if (n.includes('accountcreation') || n.includes('account')) return 'user';
//    if (n.includes('supervisor') || n.includes('eye') || n.includes('view')) return 'eye';
//    if (n.includes('supplier') || n.includes('truck') || n.includes('vendor')) return 'truck';
//    if (n.includes('manager') || n.includes('staff') || n.includes('employee')) return 'user';
//    if (n.includes('customer') || n.includes('client')) return 'users';
//    if (n.includes('attendance') || n.includes('report')) return 'report';
//    if (n.includes('product') || n.includes('store') || n.includes('inventory')) return 'order';
//    if (n.includes('order') || n.includes('bill') || n.includes('invoice')) return 'order';
//    if (n.includes('user')) return 'user';
//    return 'menu';
//  }

//  private sanitizeUgid(value?: UserGroupUgid | null): string {
//    if (value === null || value === undefined) return '';
//    const t = String(value).trim();
//    if (!t || t.toLowerCase() === 'null' || t.toLowerCase() === 'undefined') return '';
//    return t;
//  }

//  private replacePlaceholder(url: string, key: string, value?: string): string {
//    return value ? url.replace(new RegExp(`\\{${key}\\}`, 'g'), encodeURIComponent(value)) : url;
//  }
//  private appendQueryParam(url: string, key: string, value: string): string {
//    const sep = url.includes('?') ? '&' : '?';
//    return `${url}${sep}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//  }
//  private hasPlaceholder(url: string, key: string): boolean { return url.includes(`{${key}}`); }
//  private withCacheBuster(url: string): string {
//    const sep = url.includes('?') ? '&' : '?';
//    return `${url}${sep}_=${Date.now()}`;
//  }
//  private isRecord(value: unknown): value is MenuRow {
//    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
//  }
//}





// import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
// import { map } from 'rxjs/operators';
// import { BehaviorSubject, Observable, throwError } from 'rxjs';
// import { Menu } from '../../model/menu.model';
// import { CoreGymService } from '../../_services/core.gym.service.service';
// import { Guid } from '../../_helpers/guid';

// export type UserGroupUgid = string;

// export interface DashboardMenuRequest {
//   apiUrl: string;
//   productUId?: string;
//   userGroupUgid?: UserGroupUgid;
//   productParamName?: string;
//   ugidParamName?: string;
// }

// export interface DashboardMenuItem {
//   id: string;
//   label: string;
//   iconKey: string;
//   route?: string;
//   badge?: string;
//   hint?: string;
//   accentClass?: string;
//   dashboardGroup?: string;
//   showInDashboard?: boolean;
//   sortOrder: number;
//   section: string;
//   toastTitle?: string;
//   toastMessage?: string;
// }

// export interface DashboardMenuSection {
//   label: string;
//   sortOrder: number;
//   items: DashboardMenuItem[];
// }

// type MenuRow = Record<string, unknown>;

// // ─── Section inference ─────────────────────────────────────────
// // Used when the API doesn't return a usable `Section` value for a row.
// // We map menu labels / routes to one of these canonical sections and
// // give each section a stable sort order so the sidebar always groups
// // the same way regardless of row order.
// const SECTION_ORDER: Record<string, number> = {
//   'Main': 10,
//   'Account & Management': 20,
//   'Registration': 30,
//   'Customer Management': 40,
//   'Product Management': 50,
//   'Orders': 60,
//   'Payments': 70,
//   'Billing & Invoices': 80,
//   'Attendance & Reports': 90,
//   'Configuration': 100,
//   'Menu': 999,
// };

// @Injectable({
//   providedIn: 'root'
// })
// export class MenuService {
//   lostOfMenu: Array<Menu> = [];

//   private menuList = new BehaviorSubject<Array<Menu>>(this.lostOfMenu);
//   menus$ = this.menuList.asObservable();

//   constructor(
//     private readonly http: HttpClient,
//     private readonly coreGymService: CoreGymService
//   ) { }

//   setmenu(menu: Array<Menu>): void {
//     const sortedMenu = [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//     this.menuList.next(sortedMenu);
//   }

//   mergeMenu(menu: Menu, action: string): Observable<Response> {
//     let httpheader = new HttpHeaders();
//     httpheader = httpheader.append('Content-Type', 'application/json');
//     let url = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];

//     if (action === 'Edit' || action === 'Delete') {
//       url = url + '/' + menu.menuUId;
//       return this.http.put(url, JSON.stringify(menu), { headers: httpheader })
//         .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//     }

//     return this.http.post(url, JSON.stringify(menu), { headers: httpheader })
//       .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
//   }

//   getMenus(): Observable<Array<Menu>> {
//     let url = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//     return this.http.get<Array<Menu>>(url)
//       .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//   }

//   getMenuById(menuUId: string): Observable<Array<Menu>> {
//     let url = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetMenuUIdUrl'];
//     url = url.replace('{id}', menuUId || Guid.empty);
//     return this.http.get<Array<Menu>>(url)
//       .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//   }

//   getDashboardMenus(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//     return this.getDashboardMenu(request);
//   }

//   // getDashboardMenusProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<DashboardMenuSection[]> {
//   //   if (!productUId) {
//   //     return throwError(new Error('ProductUId is required to load dashboard menus.'));
//   //   }

//   //   const url = this.coreGymService.BaseUrl! + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//   //   return this.getDashboardMenu({
//   //     apiUrl: url,
//   //     productUId,
//   //     userGroupUgid: this.sanitizeUgid(userGroupUgid),
//   //     productParamName: 'ProductUId',
//   //     ugidParamName: 'RoleBasedMenus',
//   //   });
//   // }


//   // getDashboardMenusProduct(productUId: string, ugid: string) {
//   //   let params = new HttpParams().set('ProductUId', productUId || '');
//   //   if (ugid) { params = params.set('UGID', ugid); }   // omit when empty (admin)
//   //   // set RoleBasedMenus to whatever your API expects, e.g. a bool:
//   //   params = params.set('RoleBasedMenus', ugid ? 'true' : 'false');
//   //   // return this.http.get<DashboardMenuSection[]>(${ this.baseUrl }Menus, { params });
//   //   const url = this.coreGymService.BaseUrl + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//   // }

//   // getDashboardMenusProduct(productUId: string, ugid: string): Observable<DashboardMenuSection[]> {
//   //   const url = this.coreGymService.BaseUrl + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];

//   //   // let params = new HttpParams().set('ProductUId', productUId || '');
//   //   // if (ugid) { params = params.set('UGID', ugid); }               // omit when empty (admin)
//   //   // params = params.set('RoleBasedMenus', ugid ? 'true' : 'false');
//   //   let params = new HttpParams().set('ProductUId', productUId || '');
//   //   if (ugid) { params = params.set('RoleBasedMenus', ugid); }   // <-- name your API expects
//   //   return this.http.get<DashboardMenuSection[]>(url, { params });

//   //   //return this.http.get<DashboardMenuSection[]>(url, { params });
//   // }


//   getDashboardMenusProduct(productUId: string, ugid: string): Observable<DashboardMenuSection[]> {
//     // Endpoint from serviceUrls may include a "?ProductUId={ProductUId}&..." template — drop it.
//     let url = this.coreGymService.BaseUrl + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//     url = url.split('?')[0];   // <-- removes the {ProductUId}&{RoleBasedMenus} template

//     let params = new HttpParams().set('ProductUId', productUId || '');
//     params = params.set('ugid', ugid  || Guid.empty);
//     if (ugid) { params = params.set('UGID', ugid); }   // only if your API actually reads UGID

//     return this.http.get<DashboardMenuSection[]>(url, { params });
//   }

//   getMenu(): Observable<Array<Menu>>;
//   getMenu(menuUId: string): Observable<Array<Menu>>;
//   getMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]>;
//   getMenu(menuUIdOrRequest?: string | DashboardMenuRequest): Observable<Array<Menu> | DashboardMenuSection[]> {
//     if (menuUIdOrRequest && typeof menuUIdOrRequest === 'object') {
//       return this.getDashboardMenus(menuUIdOrRequest);
//     }
//     if (menuUIdOrRequest) {
//       return this.getMenuById(menuUIdOrRequest.toString());
//     }
//     return this.getMenus();
//   }

//   getMenuProduct(productUId?: string, userGroupUgid?: UserGroupUgid | null): Observable<Array<Menu>> {
//     let url = this.coreGymService.BaseUrl!;
//     if (!productUId) {
//       url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//       return this.http.get<Array<Menu>>(url)
//         .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//     }

//     const ugid = this.sanitizeUgid(userGroupUgid);
//     url = url + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
//     url = url.replace('{ProductUId}', productUId || Guid.empty);
//     url = url.replace('{RoleBasedMenus}', ugid ?? '');
//     url = url.replace('{UGID}', ugid ?? '');
//     // url = url.replace('{RoleBasedMenus}', ugid || Guid.empty);
//     //url = url.replace('{UGID}', ugid || Guid.empty);

//     return this.http.get<Array<Menu>>(url)
//       .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
//   }

//   deleteMenu(menuUId: Guid): Observable<Array<Menu>> {
//     let url = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
//     url = url + '/' + menuUId;
//     return this.http.delete<Array<Menu>>(url)
//       .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
//   }

//   private getDashboardMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
//     const sanitizedRequest: DashboardMenuRequest = {
//       ...request,
//       userGroupUgid: this.sanitizeUgid(request.userGroupUgid),
//     };
//     return this.http
//       .get<unknown>(this.buildDashboardMenuUrl(sanitizedRequest))
//       .pipe(map((response) => this.toDashboardSections(response)));
//   }

//   private buildDashboardMenuUrl(request: DashboardMenuRequest): string {
//     const productParamName = request.productParamName || 'ProductUId';
//     const ugidParamName = request.ugidParamName || 'RoleBasedMenus';
//     let url = request.apiUrl;

//     url = this.replacePlaceholder(url, productParamName, request.productUId);
//     url = this.replacePlaceholder(url, 'ProductUId', request.productUId);
//     url = this.replacePlaceholder(url, ugidParamName, request.userGroupUgid);
//     url = this.replacePlaceholder(url, 'RoleBasedMenus', request.userGroupUgid);
//     url = this.replacePlaceholder(url, 'UGID', request.userGroupUgid);
//     url = this.replacePlaceholder(url, 'UserGroupUgid', request.userGroupUgid);

//     if (request.productUId && !this.hasPlaceholder(request.apiUrl, productParamName) && !this.hasPlaceholder(request.apiUrl, 'ProductUId')) {
//       url = this.appendQueryParam(url, productParamName, request.productUId);
//     }
//     if (request.userGroupUgid &&
//       !this.hasPlaceholder(request.apiUrl, ugidParamName) &&
//       !this.hasPlaceholder(request.apiUrl, 'RoleBasedMenus') &&
//       !this.hasPlaceholder(request.apiUrl, 'UGID') &&
//       !this.hasPlaceholder(request.apiUrl, 'UserGroupUgid')) {
//       url = this.appendQueryParam(url, ugidParamName, request.userGroupUgid);
//     }
//     return this.withCacheBuster(url);
//   }

//   private toDashboardSections(response: unknown): DashboardMenuSection[] {
//     const rows = this.extractRows(response);
//     const activeRows = rows.filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true));
//     const sectionMap = new Map<string, DashboardMenuSection>();

//     activeRows.forEach((row, index) => {
//       const item = this.toDashboardMenuItem(row, index);
//       if (!item.label) return;

//       if (!sectionMap.has(item.section)) {
//         sectionMap.set(item.section, {
//           label: item.section,
//           sortOrder: SECTION_ORDER[item.section] ??
//             this.readNumber(row, ['section_order', 'sectionOrder', 'group_order'], 500 + sectionMap.size),
//           items: [],
//         });
//       }
//       sectionMap.get(item.section)?.items.push(item);
//     });

//     return Array.from(sectionMap.values())
//       .map((s) => ({ ...s, items: s.items.sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label)) }))
//       .sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label));
//   }

//   private toDashboardMenuItem(row: MenuRow, index: number): DashboardMenuItem {
//     const label = this.readString(row, ['title', 'Title', 'menu_name', 'menuName', 'MenuName', 'label', 'name']);
//     const route = this.readString(row, ['page', 'Page', 'route', 'routerLink', 'router_link', 'path', 'url']);
//     const rawIcon = this.readString(row, ['icon', 'Icon', 'icon_key', 'iconKey', 'icon_name', 'iconName']);
//     const apiSect = this.readString(row, ['section', 'Section', 'section_name', 'sectionName', 'menu_group', 'menuGroup']);
//     const section = this.resolveSection(apiSect, label, route);

//     return {
//       id: this.readString(row, ['menuUId', 'MenuUId', 'menu_id', 'menuId', 'id']) || `${section}-${label || index}`,
//       label,
//       section,
//       route,
//       iconKey: this.toIconKey(rawIcon || label || section),
//       badge: this.readString(row, ['badgeValue', 'BadgeValue', 'badge', 'badge_count']),
//       hint: this.readString(row, ['description', 'hint', 'subtitle']),
//       sortOrder: this.readNumber(row, ['displayOrder', 'DisplayOrder', 'sort_order', 'sortOrder'], index + 1),
//       showInDashboard: this.readOptionalBoolean(row, ['show_on_dashboard', 'showOnDashboard']) ?? label.toLowerCase() !== 'dashboard',
//     };
//   }

//   /**
//    * Picks the section a menu row belongs to.
//    *
//    * If the API gives us a real-looking section name (not "Menu", "MENU",
//    * "Default", or empty), we trust it. Otherwise we infer from the label
//    * and route using keyword matching, so existing menu tables that don't
//    * have section columns still produce a properly grouped sidebar.
//    */
//   private resolveSection(apiSection: string, label: string, route: string): string {
//     const trimmed = (apiSection || '').trim();
//     const lower = trimmed.toLowerCase();
//     const isPlaceholder = !trimmed || lower === 'menu' || lower === 'default' || lower === 'main menu' || lower === 'navigation';
//     if (!isPlaceholder) {
//       return trimmed;
//     }
//     return this.inferSection(label, route);
//   }

//   private inferSection(label: string, route: string): string {
//     const haystack = `${label} ${route}`.toLowerCase();
//     const has = (...needles: string[]) => needles.some((n) => haystack.includes(n));

//     if (has('dashboard', 'home', 'overview')) return 'Main';
//     if (has('account creation', 'accountcreation', 'account')) return 'Account & Management';
//     if (has('manager', 'supervisor', 'supplier', 'staff', 'employee')) return 'Registration';
//     if (has('customer', 'client', 'guest')) return 'Customer Management';
//     if (has('product', 'store', 'inventory', 'stock', 'item')) return 'Product Management';
//     if (has('order')) return 'Orders';
//     if (has('payment', 'receipt')) return 'Payments';
//     if (has('invoice', 'bill')) return 'Billing & Invoices';
//     if (has('attendance', 'report')) return 'Attendance & Reports';
//     if (has('tax', 'setup', 'setting', 'config', 'master')) return 'Configuration';

//     return 'Menu';
//   }

//   private sortMenu(menu: Array<Menu>): Array<Menu> {
//     return [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
//   }

//   private extractRows(response: unknown): MenuRow[] {
//     if (Array.isArray(response)) return response.filter(this.isRecord);
//     if (!this.isRecord(response)) return [];
//     const candidates = [response['data'], response['menus'], response['menu'], response['items'], response['rows'], response['result']];
//     for (const c of candidates) if (Array.isArray(c)) return c.filter(this.isRecord);
//     return [];
//   }

//   private readString(row: MenuRow, keys: string[]): string {
//     for (const key of keys) {
//       const value = row[key];
//       if (value !== undefined && value !== null && String(value).trim() !== '') return String(value).trim();
//     }
//     return '';
//   }

//   private readNumber(row: MenuRow, keys: string[], fallback: number): number {
//     for (const key of keys) {
//       const parsed = Number(row[key]);
//       if (Number.isFinite(parsed)) return parsed;
//     }
//     return fallback;
//   }

//   private readBoolean(row: MenuRow, keys: string[], fallback: boolean): boolean {
//     const v = this.readOptionalBoolean(row, keys);
//     return v ?? fallback;
//   }

//   private readOptionalBoolean(row: MenuRow, keys: string[]): boolean | null {
//     for (const key of keys) {
//       if (!(key in row)) continue;
//       const v = row[key];
//       if (typeof v === 'boolean') return v;
//       if (typeof v === 'number') return v === 1;
//       if (typeof v === 'string') return ['1', 'true', 'yes', 'y', 'active'].includes(v.trim().toLowerCase());
//     }
//     return null;
//   }

//   private toIconKey(value: string): string {
//     const n = value.toLowerCase().replace(/[^a-z0-9]+/g, '');
//     if (n.includes('dashboard') || n.includes('home')) return 'dashboard';
//     if (n.includes('accountcreation') || n.includes('account')) return 'user';
//     if (n.includes('supervisor') || n.includes('eye') || n.includes('view')) return 'eye';
//     if (n.includes('supplier') || n.includes('truck') || n.includes('vendor')) return 'truck';
//     if (n.includes('manager') || n.includes('staff') || n.includes('employee')) return 'user';
//     if (n.includes('customer') || n.includes('client')) return 'users';
//     if (n.includes('attendance') || n.includes('report')) return 'report';
//     if (n.includes('product') || n.includes('store') || n.includes('inventory')) return 'order';
//     if (n.includes('order') || n.includes('bill') || n.includes('invoice')) return 'order';
//     if (n.includes('user')) return 'user';
//     return 'menu';
//   }

//   private sanitizeUgid(value?: UserGroupUgid | null): string {
//     if (value === null || value === undefined) return '';
//     const t = String(value).trim();
//     if (!t || t.toLowerCase() === 'null' || t.toLowerCase() === 'undefined') return '';
//     return t;
//   }

//   private replacePlaceholder(url: string, key: string, value?: string): string {
//     return value ? url.replace(new RegExp(`\\{${key}\\}`, 'g'), encodeURIComponent(value)) : url;
//   }
//   private appendQueryParam(url: string, key: string, value: string): string {
//     const sep = url.includes('?') ? '&' : '?';
//     return `${url}${sep}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//   }
//   private hasPlaceholder(url: string, key: string): boolean { return url.includes(`{${key}}`); }
//   private withCacheBuster(url: string): string {
//     const sep = url.includes('?') ? '&' : '?';
//     return `${url}${sep}_=${Date.now()}`;
//   }
//   private isRecord(value: unknown): value is MenuRow {
//     return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
//   }
// }



import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { Menu } from '../../model/menu.model';
import { CoreGymService } from '../../_services/core.gym.service.service';
import { Guid } from '../../_helpers/guid';

export type UserGroupUgid = string;

export interface DashboardMenuRequest {
  apiUrl: string;
  productUId?: string;
  userGroupUgid?: UserGroupUgid;
  productParamName?: string;
  ugidParamName?: string;
}

export interface DashboardMenuItem {
  id: string;
  label: string;
  iconKey: string;
  route?: string;
  badge?: string;
  hint?: string;
  accentClass?: string;
  dashboardGroup?: string;
  showInDashboard?: boolean;
  sortOrder: number;
  section: string;
  toastTitle?: string;
  toastMessage?: string;
}

export interface DashboardMenuSection {
  label: string;
  sortOrder: number;
  items: DashboardMenuItem[];
}

type MenuRow = Record<string, unknown>;

// ─── Section inference ─────────────────────────────────────────
// Used when the API doesn't return a usable `Section` value for a row.
// We map menu labels / routes to one of these canonical sections and
// give each section a stable sort order so the sidebar always groups
// the same way regardless of row order.
const SECTION_ORDER: Record<string, number> = {
  'Main': 10,
  'Account & Management': 20,
  'Registration': 30,
  'Customer Management': 40,
  'Product Management': 50,
  'Orders': 60,
  'Payments': 70,
  'Billing & Invoices': 80,
  'Attendance & Reports': 90,
  'Configuration': 100,
  'Menu': 999,
};

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  lostOfMenu: Array<Menu> = [];

  private menuList = new BehaviorSubject<Array<Menu>>(this.lostOfMenu);
  menus$ = this.menuList.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly coreGymService: CoreGymService
  ) { }

  setmenu(menu: Array<Menu>): void {
    const sortedMenu = [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
    this.menuList.next(sortedMenu);
  }

  mergeMenu(menu: Menu, action: string): Observable<Response> {
    let httpheader = new HttpHeaders();
    httpheader = httpheader.append('Content-Type', 'application/json');
    let url = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];

    if (action === 'Edit' || action === 'Delete') {
      url = url + '/' + menu.menuUId;
      return this.http.put(url, JSON.stringify(menu), { headers: httpheader })
        .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
    }

    return this.http.post(url, JSON.stringify(menu), { headers: httpheader })
      .pipe(map((data: Response) => data, (error: HttpErrorResponse): void => console.log(error)));
  }

  getMenus(): Observable<Array<Menu>> {
    let url = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
    return this.http.get<Array<Menu>>(url)
      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
  }

  getMenuById(menuUId: string): Observable<Array<Menu>> {
    let url = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['GetMenuUIdUrl'];
    url = url.replace('{id}', menuUId || Guid.empty);
    return this.http.get<Array<Menu>>(url)
      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
  }

  getDashboardMenus(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
    return this.getDashboardMenu(request);
  }

  getDashboardMenusProduct(ProductUId: string, RoleBasedMenus: string): Observable<DashboardMenuSection[]> {
    // Endpoint from serviceUrls may include a "?ProductUId={ProductUId}&..." template — drop it.
    let url = this.coreGymService.BaseUrl + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
    url = url.split('?')[0];   // <-- removes the {ProductUId}&{RoleBasedMenus} template

    let params = new HttpParams().set('ProductUId', ProductUId || '');
    params = params.set('RoleBasedMenus', RoleBasedMenus || Guid.empty);
    //if (ugid) { params = params.set('UGID', ugid); }   // only if your API actually reads UGID

    // FIXED (dynamic-menu regression, part 2): MenusController.GetMenu returns a FLAT array of raw
    // Menu rows (confirmed via the browser's own Network tab — {menuUId, ...} objects, not
    // {label, sortOrder, items} sections) — this used to cast that raw response straight to
    // DashboardMenuSection[] without transforming it, so VerticalNav.ts's `sections.items` was
    // always undefined even though the HTTP call itself succeeded with real data. getDashboardMenu()
    // right above already pipes its response through toDashboardSections() for exactly this reason;
    // this method just never did the same. Piping through it here is the fix — same grouping logic,
    // same field-alias tolerance, no change to what the backend is asked for or which roles see
    // which menus.
    return this.http.get<unknown>(url, { params })
      .pipe(map((response) => this.toDashboardSections(response)));
  }

  getMenu(): Observable<Array<Menu>>;
  getMenu(menuUId: string): Observable<Array<Menu>>;
  getMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]>;
  getMenu(menuUIdOrRequest?: string | DashboardMenuRequest): Observable<Array<Menu> | DashboardMenuSection[]> {
    if (menuUIdOrRequest && typeof menuUIdOrRequest === 'object') {
      return this.getDashboardMenus(menuUIdOrRequest);
    }
    if (menuUIdOrRequest) {
      return this.getMenuById(menuUIdOrRequest.toString());
    }
    return this.getMenus();
  }

  getMenuProduct(ProductUId?: string, RoleBasedMenus?:string): Observable<Array<Menu>> {
    let url = this.coreGymService.BaseUrl!;
    if (!ProductUId) {
      url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
      return this.http.get<Array<Menu>>(url)
        .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
    }
    else { 
      const ugid = this.sanitizeUgid(RoleBasedMenus);
    url = url + this.coreGymService.serviceUrls!['GetMenuFilterProduct'];
      url = url.replace('{ProductUId}', ProductUId || Guid.empty);
      url = url.replace('{RoleBasedMenus}', ugid || Guid.empty);
    //url = url.replace('{UGID}', ugid ?? '');

    return this.http.get<Array<Menu>>(url)
        .pipe(map((data: Array<Menu>): Array<Menu> => this.sortMenu(data), (_error: HttpErrorResponse) => []));
    }
  }

  deleteMenu(menuUId: Guid): Observable<Array<Menu>> {
    let url = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['GetMenuUrl'];
    url = url + '/' + menuUId;
    return this.http.delete<Array<Menu>>(url)
      .pipe(map((data: Array<Menu>): Array<Menu> => data, (_error: HttpErrorResponse) => []));
  }

  private getDashboardMenu(request: DashboardMenuRequest): Observable<DashboardMenuSection[]> {
    const sanitizedRequest: DashboardMenuRequest = {
      ...request,
      userGroupUgid: this.sanitizeUgid(request.userGroupUgid),
    };
    return this.http
      .get<unknown>(this.buildDashboardMenuUrl(sanitizedRequest))
      .pipe(map((response) => this.toDashboardSections(response)));
  }

  private buildDashboardMenuUrl(request: DashboardMenuRequest): string {
    const productParamName = request.productParamName || 'ProductUId';
    const ugidParamName = request.ugidParamName || 'RoleBasedMenus';
    let url = request.apiUrl;

    url = this.replacePlaceholder(url, productParamName, request.productUId);
    url = this.replacePlaceholder(url, 'ProductUId', request.productUId);
    url = this.replacePlaceholder(url, ugidParamName, request.userGroupUgid);
    url = this.replacePlaceholder(url, 'RoleBasedMenus', request.userGroupUgid);
    url = this.replacePlaceholder(url, 'UGID', request.userGroupUgid);
    url = this.replacePlaceholder(url, 'UserGroupUgid', request.userGroupUgid);

    if (request.productUId && !this.hasPlaceholder(request.apiUrl, productParamName) && !this.hasPlaceholder(request.apiUrl, 'ProductUId')) {
      url = this.appendQueryParam(url, productParamName, request.productUId);
    }
    if (request.userGroupUgid &&
      !this.hasPlaceholder(request.apiUrl, ugidParamName) &&
      !this.hasPlaceholder(request.apiUrl, 'RoleBasedMenus') &&
      !this.hasPlaceholder(request.apiUrl, 'UGID') &&
      !this.hasPlaceholder(request.apiUrl, 'UserGroupUgid')) {
      url = this.appendQueryParam(url, ugidParamName, request.userGroupUgid);
    }
    return this.withCacheBuster(url);
  }

  private toDashboardSections(response: unknown): DashboardMenuSection[] {
    const rows = this.extractRows(response);
    const activeRows = rows.filter((row) => this.readBoolean(row, ['is_active', 'isActive', 'active', 'IsActive'], true));
    const sectionMap = new Map<string, DashboardMenuSection>();

    activeRows.forEach((row, index) => {
      const item = this.toDashboardMenuItem(row, index);
      if (!item.label) return;

      if (!sectionMap.has(item.section)) {
        sectionMap.set(item.section, {
          label: item.section,
          sortOrder: SECTION_ORDER[item.section] ??
            this.readNumber(row, ['section_order', 'sectionOrder', 'group_order'], 500 + sectionMap.size),
          items: [],
        });
      }
      sectionMap.get(item.section)?.items.push(item);
    });

    return Array.from(sectionMap.values())
      .map((s) => ({ ...s, items: s.items.sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label)) }))
      .sort((a, b) => a.sortOrder - b.sortOrder || a.label.localeCompare(b.label));
  }

  private toDashboardMenuItem(row: MenuRow, index: number): DashboardMenuItem {
    const label = this.readString(row, ['title', 'Title', 'menu_name', 'menuName', 'MenuName', 'label', 'name']);
    const route = this.readString(row, ['page', 'Page', 'route', 'routerLink', 'router_link', 'path', 'url']);
    const rawIcon = this.readString(row, ['icon', 'Icon', 'icon_key', 'iconKey', 'icon_name', 'iconName']);
    const apiSect = this.readString(row, ['section', 'Section', 'section_name', 'sectionName', 'menu_group', 'menuGroup']);
    const section = this.resolveSection(apiSect, label, route);

    return {
      id: this.readString(row, ['menuUId', 'MenuUId', 'menu_id', 'menuId', 'id']) || `${section}-${label || index}`,
      label,
      section,
      route,
      iconKey: this.toIconKey(rawIcon || label || section),
      badge: this.readString(row, ['badgeValue', 'BadgeValue', 'badge', 'badge_count']),
      hint: this.readString(row, ['description', 'hint', 'subtitle']),
      sortOrder: this.readNumber(row, ['displayOrder', 'DisplayOrder', 'sort_order', 'sortOrder'], index + 1),
      showInDashboard: this.readOptionalBoolean(row, ['show_on_dashboard', 'showOnDashboard']) ?? label.toLowerCase() !== 'dashboard',
    };
  }

  /**
   * Picks the section a menu row belongs to.
   *
   * If the API gives us a real-looking section name (not "Menu", "MENU",
   * "Default", or empty), we trust it. Otherwise we infer from the label
   * and route using keyword matching, so existing menu tables that don't
   * have section columns still produce a properly grouped sidebar.
   */
  private resolveSection(apiSection: string, label: string, route: string): string {
    const trimmed = (apiSection || '').trim();
    const lower = trimmed.toLowerCase();
    const isPlaceholder = !trimmed || lower === 'menu' || lower === 'default' || lower === 'main menu' || lower === 'navigation';
    if (!isPlaceholder) {
      return trimmed;
    }
    return this.inferSection(label, route);
  }

  private inferSection(label: string, route: string): string {
    const haystack = `${label} ${route}`.toLowerCase();
    const has = (...needles: string[]) => needles.some((n) => haystack.includes(n));

    if (has('dashboard', 'home', 'overview')) return 'Main';
    if (has('account creation', 'accountcreation', 'account')) return 'Account & Management';
    if (has('manager', 'supervisor', 'supplier', 'staff', 'employee')) return 'Registration';
    if (has('customer', 'client', 'guest')) return 'Customer Management';
    if (has('product', 'store', 'inventory', 'stock', 'item')) return 'Product Management';
    if (has('order')) return 'Orders';
    if (has('payment', 'receipt')) return 'Payments';
    if (has('invoice', 'bill')) return 'Billing & Invoices';
    if (has('attendance', 'report')) return 'Attendance & Reports';
    if (has('tax', 'setup', 'setting', 'config', 'master')) return 'Configuration';

    return 'Menu';
  }

  private sortMenu(menu: Array<Menu>): Array<Menu> {
    return [...(menu || [])].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
  }

  private extractRows(response: unknown): MenuRow[] {
    if (Array.isArray(response)) return response.filter(this.isRecord);
    if (!this.isRecord(response)) return [];
    const candidates = [response['data'], response['menus'], response['menu'], response['items'], response['rows'], response['result']];
    for (const c of candidates) if (Array.isArray(c)) return c.filter(this.isRecord);
    return [];
  }

  private readString(row: MenuRow, keys: string[]): string {
    for (const key of keys) {
      const value = row[key];
      if (value !== undefined && value !== null && String(value).trim() !== '') return String(value).trim();
    }
    return '';
  }

  private readNumber(row: MenuRow, keys: string[], fallback: number): number {
    for (const key of keys) {
      const parsed = Number(row[key]);
      if (Number.isFinite(parsed)) return parsed;
    }
    return fallback;
  }

  private readBoolean(row: MenuRow, keys: string[], fallback: boolean): boolean {
    const v = this.readOptionalBoolean(row, keys);
    return v ?? fallback;
  }

  private readOptionalBoolean(row: MenuRow, keys: string[]): boolean | null {
    for (const key of keys) {
      if (!(key in row)) continue;
      const v = row[key];
      if (typeof v === 'boolean') return v;
      if (typeof v === 'number') return v === 1;
      if (typeof v === 'string') return ['1', 'true', 'yes', 'y', 'active'].includes(v.trim().toLowerCase());
    }
    return null;
  }

  private toIconKey(value: string): string {
    const n = value.toLowerCase().replace(/[^a-z0-9]+/g, '');
    if (n.includes('dashboard') || n.includes('home')) return 'dashboard';
    if (n.includes('accountcreation') || n.includes('account')) return 'user';
    if (n.includes('supervisor') || n.includes('eye') || n.includes('view')) return 'eye';
    if (n.includes('supplier') || n.includes('truck') || n.includes('vendor')) return 'truck';
    if (n.includes('manager') || n.includes('staff') || n.includes('employee')) return 'user';
    if (n.includes('customer') || n.includes('client')) return 'users';
    if (n.includes('attendance') || n.includes('report')) return 'report';
    if (n.includes('product') || n.includes('store') || n.includes('inventory')) return 'order';
    if (n.includes('order') || n.includes('bill') || n.includes('invoice')) return 'order';
    if (n.includes('user')) return 'user';
    return 'menu';
  }

  private sanitizeUgid(value?: UserGroupUgid | null): string {
    if (value === null || value === undefined) return '';
    const t = String(value).trim();
    if (!t || t.toLowerCase() === 'null' || t.toLowerCase() === 'undefined') return '';
    return t;
  }

  private replacePlaceholder(url: string, key: string, value?: string): string {
    return value ? url.replace(new RegExp(`\\{${key}\\}`, 'g'), encodeURIComponent(value)) : url;
  }
  private appendQueryParam(url: string, key: string, value: string): string {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }
  private hasPlaceholder(url: string, key: string): boolean { return url.includes(`{${key}}`); }
  private withCacheBuster(url: string): string {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}_=${Date.now()}`;
  }
  private isRecord(value: unknown): value is MenuRow {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
  }
}



